import {
    BrowserInfo,
    THREE
} from 'GT3DEngine-module';
// require('jquery-circle-progress');
// const $ = require('jquery');
const AlloyFinger = require('alloyfinger');
const qiniu = require('qiniu-js');
import axios from 'axios';
import './css/index.css';
// import GT3DBaseView from 'GT3DBaseView-module';
import GT3DBaseView from '@/libs/GT3DBaseView';

const ACTION = {
    None: 0,
    DragMove: 1,
    DragScale: 2,
    DragXYRotate: 3,
    DragZRotate: 4,
    PinchScale: 5,
    TwistRotate: 6,
    DragShrink: 7,
    DragExpand: 8,
};

export default class GT3DTryon extends GT3DBaseView {
    constructor(options) {
        super(options)
        this.initTryonFace();
        this.initUI();
        this.startLoadScene();
    }

    initRenderer() {
        let canvas = document.createElement('canvas')
        let context = canvas.getContext('webgl2')
        const renderer = this.renderer = new THREE.WebGLRenderer({
            canvas: canvas,
            context: context,
            // alpha: this.options.alpha,
            antialias: this.options.antialias
        })
        renderer.setSize(this.options.width, this.options.height)
        renderer.setPixelRatio(this.options.pixelRatio)
        renderer.setClearColor(new THREE.Color("rgb(170, 170, 170)"));
        renderer.shadowMap.enabled = true;
        this.options.element.appendChild && this.options.element.appendChild(renderer.domElement)
    }

    // initScene() {
    //     super.initScene();
    // }

    initCamera() {
        const camera = this.camera = new THREE.OrthographicCamera(-this.options.width / 2, this.options.width / 2, this.options.height / 2, -this.options.height / 2, 0, 10000);
        camera.position.x = 0;
        camera.position.y = 0;
        camera.position.z = 5000;
    }

    initLights() {
        let directionalLight = this.directionalLight = new THREE.DirectionalLight(0xffffff, 0.3);
        this.scene.add(directionalLight);
        directionalLight.position.x = 0;
        directionalLight.position.y = 50;
        directionalLight.position.z = 500;
        directionalLight.target = this.scene;
        directionalLight.castShadow = true;
        directionalLight.shadow.mapSize.width = 2048;
        directionalLight.shadow.mapSize.height = 2048;
        directionalLight.shadow.camera.left = this.camera.left;
        directionalLight.shadow.camera.right = this.camera.right;
        directionalLight.shadow.camera.top = this.camera.top;
        directionalLight.shadow.camera.bottom = this.camera.bottom;
        directionalLight.shadow.camera.near = 0;
        directionalLight.shadow.camera.far = 10000;
        directionalLight.shadow.camera.updateProjectionMatrix();
        directionalLight.shadow.bias = -0.001;

        let ambientLight = new THREE.AmbientLight(0xffffff, 0.7);
        this.scene.add(ambientLight);
    }

    initControls() {
        this.onMouseDown = this.onMouseDown.bind(this);
        this.onMouseWheel = this.onMouseWheel.bind(this);
        this.onMouseMove = this.onMouseMove.bind(this);
        this.onMouseUp = this.onMouseUp.bind(this);

        this.options.element.addEventListener('mousedown', this.onMouseDown, false);
        this.options.element.addEventListener('wheel', this.onMouseWheel, false);
        this.options.element.addEventListener('mousemove', this.onMouseMove, false);
        this.options.element.addEventListener('mouseup', this.onMouseUp, false);
        this.options.element.addEventListener('mouseleave', this.onMouseUp, false);

        this.alloyFinger = new AlloyFinger(this.options.element, {
            touchStart: (evt) => {
                // console.log("touchStart: ", evt);
                // evt.preventDefault();
                evt.stopPropagation();
                // debugElement.textContent = 'touchStart: ' + action + ', ' + evt.touches.length;
                if (this.action != ACTION.None || evt.touches.length != 1) {
                    return;
                }
                this.touchStartEvent = this.preTouchEvent = evt.touches[0];
                this.checkRaycastObject(evt.touches[0].clientX, evt.touches[0].clientY);
                // checkAction(evt.touches[0].clientX, evt.touches[0].clientY);
                // debugElement.textContent = 'touchStart: ' + action;
            },
            touchMove: (evt) => {
                // console.log("touchMove: ", evt);
                // evt.preventDefault();
                evt.stopPropagation();
            },
            touchEnd: (evt) => {
                // console.log("touchEnd: ", evt);
                // evt.preventDefault();
                evt.stopPropagation();
                this.touchStartEvent = this.preTouchEvent = null;
                this.action = ACTION.None;
                // debugElement.textContent = 'touchEnd: ' + action;
            },
            touchCancel: (evt) => {
                // console.log("touchCancel: ", evt);
                // evt.preventDefault();
                evt.stopPropagation();
                this.touchStartEvent = this.preTouchEvent = null;
                this.action = ACTION.None;
            },
            // multipointStart: function (evt) {
            //  console.log("multipointStart: ", evt);
            // },
            // multipointEnd: function (evt) {
            //  console.log("multipointEnd: ", evt);
            // },
            // tap: function (evt) {
            //  console.log("tap: ", evt);
            // },
            doubleTap: (evt) => {
                // console.log("doubleTap: ", evt);
                if (this.selectedObject === this.tryonImagePlane)
                    this.resetTryonImageProperties();
            },
            // longTap: function (evt) {
            //  console.log("longTap: ", evt);
            // },
            singleTap: (evt) => {
                // console.log("singleTap: ", evt);
                // preTouchEvent = evt.changedTouches[0];
                // checkRaycastObject(evt.changedTouches[0].clientX, evt.changedTouches[0].clientY);
                // debugElement.textContent = 'singleTap: ' + action;
            },
            rotate: (evt) => {
                // console.log("rotate: ", evt);
                if (this.selectedObject != null && this.selectedObject !== this.tryonImagePlane) {
                    this.selectedObject.rotateZOnWorld(-evt.angle);
                    this.canSaveTryonData = true;
                }
            },
            pinch: (evt) => {
                // console.log("pinch: ", evt);
                if (this.selectedObject == null || this.selectedObject === this.tryonImagePlane) {
                    this.pinchZoomTryonImage(evt.zoom);
                } else {
                    this.pinchZoomObject(this.selectedObject, evt.zoom, this.tryonObjectMinScale, this.tryonObjectMaxScale);
                }
            },
            pressMove: (evt) => {
                // console.log("pressMove: ", evt);
                // debugElement.textContent = 'pressMove: ' + action;
                switch (this.action) {
                    case ACTION.DragScale:
                        this.dragScaleObjectInTouch(this.selectedObject, evt.touches[0], this.btn_scale.getWorldPosition(new THREE.Vector3()), this.tryonObjectMinScale, this.tryonObjectMaxScale);
                        return;
                    case ACTION.DragZRotate:
                        this.dragZRotateObjectInTouch(this.selectedObject, evt.touches[0]);
                        return;
                    case ACTION.DragXYRotate:
                        this.dragXYRotateObject(this.selectedObject, evt.deltaX, evt.deltaY);
                        return;
                        // case ACTION.DragMove:
                        //     dragMoveObject(selectedObject, evt.deltaX, evt.deltaY);
                        //     return;
                    case ACTION.DragShrink:
                        this.dragShrinkChainOpened(this.selectedObject, evt.deltaX, evt.deltaY);
                        return;
                    case ACTION.DragExpand:
                        this.dragExpandChainOpened(selectedObject, evt.deltaX, evt.deltaY);
                        return;
                }
                this.dragMoveObject(this.selectedObject, evt.deltaX, evt.deltaY);
                this.preTouchEvent = evt.touches[0];
            },
            // twoFingerPressMove: function(evt) {
            //  console.log("twoFingerPressMove: ", evt);
            // },
            // swipe: function (evt) {
            //  console.log("swipe: ", evt);
            // }
        });
    }

    onMouseDown(event) {
        // console.log(event);
        // console.log(event.button);
        // event.preventDefault();
        event.stopPropagation();
        switch (event.button) {
            case THREE.MOUSE.LEFT:
                this.mouseDownEvent = this.preMouseEvent = event;
                this.checkRaycastObject(event.clientX, event.clientY);
                break;
        }
    }

    onMouseMove(event) {
        // console.log(event);
        // console.log(event.button);
        // event.preventDefault();
        event.stopPropagation();
        switch (event.button) {
            case THREE.MOUSE.LEFT:
                switch (this.action) {
                    case ACTION.DragScale:
                        this.dragScaleObjectInMouse(this.selectedObject, event, this.btn_scale.getWorldPosition(new THREE.Vector3()), this.tryonObjectMinScale, this.tryonObjectMaxScale);
                        return;
                    case ACTION.DragZRotate:
                        this.dragZRotateObjectInMouse(this.selectedObject, event);
                        return;
                    case ACTION.DragXYRotate:
                        this.dragXYRotateObjectInMouse(this.selectedObject, event);
                        return;
                    case ACTION.DragShrink:
                        this.dragShrinkChainOpenedInMouse(this.selectedObject, event);
                        return;
                    case ACTION.DragExpand:
                        this.dragExpandChainOpenedInMouse(this.selectedObject, event);
                        return;
                }
                this.dragMoveObjectInMouse(this.selectedObject, event);
                break;
        }
    }

    onMouseUp(event) {
        // console.log(event);
        // console.log(event.button);
        // event.preventDefault();
        event.stopPropagation();
        this.mouseDownEvent = this.preMouseEvent = null;
        this.action = ACTION.None;
    }

    onMouseWheel(event) {
        // console.log(event);
        // event.preventDefault();
        event.stopPropagation();
        if (event.deltaY < 0) {
            if (this.selectedObject === null || this.selectedObject === this.tryonImagePlane)
                this.zoomInTryonImage(this.getMouseWheelZoomScale());
            else
                this.zoomInObject(this.selectedObject, this.getMouseWheelZoomScale(), this.tryonObjectMinScale, this.tryonObjectMaxScale);
        } else if (event.deltaY > 0) {
            if (this.selectedObject === null || this.selectedObject === this.tryonImagePlane)
                this.zoomOutTryonImage(this.getMouseWheelZoomScale());
            else
                this.zoomOutObject(this.selectedObject, this.getTryonObjectZoomScale(), this.tryonObjectMinScale, this.tryonObjectMaxScale);
        }
    }

    disposeControls() {
        this.options.element.removeEventListener('mousedown', this.onMouseDown, false);
        this.options.element.removeEventListener('wheel', this.onMouseWheel, false);
        this.options.element.removeEventListener('mousemove', this.onMouseMove, false);
        this.options.element.removeEventListener('mouseup', this.onMouseUp, false);
        this.options.element.removeEventListener('mouseleave', this.onMouseUp, false);

        this.alloyFinger.destroy();
    }

    onInitialized() {
        if (this.options.useLoadingProgress === undefined)
            this.options.useLoadingProgress = true;
        if (this.options.baseDir === undefined)
            this.options.baseDir = '/editor/3dtryon/';
        this.onProgress = this.onProgress.bind(this);
        this.onError = this.onError.bind(this);

        this.browser = new BrowserInfo();
        this.baseUrl = this.ensureBaseUrl();
        this.baseDir = this.options.baseDir;
        this.productId = this.options.id;
        this.productDetail = this.options.detail;
        // this.userId = this.options.user || this.options.userId;
        // this.modelPath = this.options.model || this.options.modelId;
        // this.category = this.options.category;
        this.loginToken = this.options.token;
        if (!this.loginToken) {
            let search = 'token=';
            let idx = document.cookie.indexOf(search);
            if (idx !== -1) {
                idx += search.length;
                let end = document.cookie.indexOf(';', idx);
                if (end === -1)
                    end = document.cookie.length;
                this.loginToken = document.cookie.substring(idx, end);
            }
        }
        console.log('loginToken: ' + this.loginToken);

        this.OnlineMode = true;
        this.DebugMode = false;
        if (window.location.protocol.startsWith('file')) {
            this.DebugMode = true;
        } else {
            var search = window.location.search.toLowerCase();
            if (search.match('debug=true') || search.match('debugmode=true')) {
                this.DebugMode = true;
            }
        }

        this.customIcon = 'images/custom.svg';
        this.getQiniuTokenUrl = this.baseUrl + '/api/qiniu/token';
        this.qiniuDeleteUrl = this.baseUrl + '/api/qiniu/delete';
        this.getProductDetailUrl = this.baseUrl + '/pavilion/gem/detail';
        this.updateProductDetailUrl = this.baseUrl + '/pavilion/gem/update';
        this.tryonImageButtons = [];
        this.selectedTryonImageButton;
        this.canSaveTryonData = false;

        this.tryonImageWidth = this.options.width;
        this.tryonImageHeight = this.options.height;

        let geometry = new THREE.PlaneBufferGeometry(this.tryonImageWidth, this.tryonImageHeight);
        let material = new THREE.MeshPhongMaterial({
            color: 0xffffff,
            shininess: 0,
            side: THREE.FrontSide
        });
        this.tryonImagePlane = new THREE.Mesh(geometry, material);
        this.tryonImagePlane.name = "tryonImagePlane";
        this.tryonImagePlane.receiveShadow = true;

        this.tryonImageRoot = new THREE.Object3D();
        this.tryonImageRoot.name = "tryonImageRoot";
        this.tryonImageRoot.add(this.tryonImagePlane);
        this.resetObjectTransformProperties(this.tryonImagePlane);

        this.objectGroup = new THREE.Group();
        this.objectGroup.name = "objectGroup";
        this.objectGroup.add(this.tryonImageRoot);
        this.resetObjectTransformProperties(this.tryonImageRoot);

        this.scene.add(this.objectGroup);
        this.resetObjectTransformProperties(this.objectGroup);

        this.tryonImageMinScale = 1;
        this.tryonImageMaxScale = 2;
        this.standardSize = 1080,
            this.menuFrameSize = 400,
            this.menuBtnSize = 100;
        this.menuMinScale = 0.75,
            this.menuMaxScale = 1.5;
        this.tryonObjectBoxSize = 120,
            this.tryonObjectSize = 120,
            this.pendantObjectSize = 40,
            this.necklaceObjectSize = 300,
            this.chainMaxOpened = 15;
        this.tryonObjectArray = new Array();
        this.tryonObjectScaleRange = new THREE.Vector2(0.25, 3);
        this.tryonObjectMinScale = this.tryonObjectScaleRange.x;
        this.tryonObjectMaxScale = this.tryonObjectScaleRange.y;
        this.raycaster = new THREE.Raycaster();
        this.action = ACTION.None;

        this.createTryonObjectControlMenu(this.objectGroup);
        this.onResize();

        // $(document).on('click', 'button[btn-func]', function() {
        //     let func = $(this).attr("btn-func");
        //     if ($.isFunction(eval(func)))
        //         eval(func + "();");
        // });
    }

    initTryonFace() {
        let tryonface = this.tryonface = document.createElement('div');
        tryonface.classList.add('tryonface');
        this.options.element.appendChild(tryonface);

        let bottom_background = this.bottom_background = document.createElement('div');
        bottom_background.classList.add('bottom_background');
        tryonface.appendChild(bottom_background);

        let bottom_line = this.bottom_line = document.createElement('span');
        bottom_line.classList.add('bottom_line');
        tryonface.appendChild(bottom_line);

        let right_bar = this.right_bar = document.createElement('div');
        right_bar.classList.add('right_bar');
        tryonface.appendChild(right_bar);

        let bottom_bar = this.bottom_bar = document.createElement('div');
        bottom_bar.classList.add('bottom_bar');
        tryonface.appendChild(bottom_bar);

        let action_bar = this.action_bar = document.createElement('div');
        action_bar.classList.add('action_bar');
        tryonface.appendChild(action_bar);

        if (this.options.useLoadingProgress) {
            let loadingProgressWindow = this.loadingProgressWindow = document.createElement('div');
            loadingProgressWindow.id = "loadingProgress";
            loadingProgressWindow.classList.add('loadingProgressWindow');
            this.options.element.append(loadingProgressWindow);

            let loadingImage = document.createElement('img');
            let url = 'images/loading.gif';
            if (this.OnlineMode) {
                url = this.baseUrl + this.baseDir + url;
            }
            loadingImage.src = url;
            loadingProgressWindow.append(loadingImage);
        }
    }

    initUI() {
        this.addBackButton();
        this.addCameraButton();
        if (this.browser.isPC) {
            this.addShareButton();
        }
        this.addRotateLeftButton();
        this.addRotateRightButton();
        this.addSaveButton();
        this.addRemoveButton();
        this.hideRemoveButton();

        this.hideLoadingProgress();
    }

    //添加背景按钮
    addBackgroundButton(imgUrl, dataUrl, key) {
        let createButton = (imgUrl, dataUrl, key) => {
            //创建dom
            let wrap_div = document.createElement('div');
            wrap_div.classList.add("border-button", "btn-bgs", "wrap");
            // wrap_div.setAttribute("id", id);
            wrap_div.style.backgroundImage = "url(" + imgUrl + ")";
            wrap_div.key = key;
            wrap_div.dataUrl = dataUrl;
            return wrap_div;
        }

        let button = createButton(imgUrl, dataUrl, key);
        this.action_bar.appendChild(button);
        return button;
    }

    //删除背景按钮
    removeBackgroundButton(id) {
        let obj = document.getElementById(id);
        obj.parentNode.removeChild(obj);
    }

    //添加删除按钮
    addRemoveButton() {
        let createRemoveButton = () => {
            //创建dom
            let wrap_div = document.createElement('div');
            wrap_div.classList.add("button", "btn-delete");
            wrap_div.setAttribute("id", "removeButton");
            return wrap_div;
        }

        let button = createRemoveButton();
        button.title = '删除';

        button.onclick = () => {
            console.log("点击删除事件");
            if (confirm('是否删除当前记录？'))
                // this.removeSelectedTryonImageButton();
                this.deleteSelectedTryonData();
        };
        this.removeButton = button;
        this.bottom_bar.appendChild(button);

        return button;
    }

    hideRemoveButton() {
        if (this.removeButton)
            this.removeButton.style.display = 'none';
    }

    showRemoveButton() {
        if (this.removeButton)
            this.removeButton.style.display = 'flex';
    }

    showLoadingProgress(progress) {
        if (this.loadingProgressWindow) {
            this.loadingProgressWindow.style.display = 'flex';

            // $('#loadingProgress').circleProgress({
            //     value: progress,
            //     animation: false,
            //     lineCap: 'round',
            //     size: 150,
            //     //rgb: 3,121,252
            //     fill: {
            //         color: '#0379fc'
            //     }
            // });
        }
        if (this.options.onShowLoadingProgress)
            this.options.onShowLoadingProgress(progress);
    }

    hideLoadingProgress(delay) {
        if (delay) {
            this.showLoadingProgress(1);
            setTimeout(() => {
                this.hideLoadingProgress();
            }, delay);
            return;
        }
        if (this.loadingProgressWindow)
            this.loadingProgressWindow.style.display = 'none';
        if (this.options.onHideLoadingProgress)
            this.options.onHideLoadingProgress();
    }

    //添加保存按钮
    addSaveButton() {
        let createSaveButton = () => {
            //创建dom
            let wrap_div = document.createElement('div');
            wrap_div.classList.add("button", "btn-save");
            wrap_div.setAttribute("id", "saveButton");
            return wrap_div;
        }

        let button = createSaveButton();
        button.title = '保存';

        button.onclick = () => {
            console.log("点击保存事件", this.canSaveTryonData);
            // alert('点击保存事件, ' + canSaveTryonData + ' ' + localStorageKey);
            if (this.DebugMode) {
                this.saveTryonDataToFile();
                return;
            }

            if (!this.canSaveTryonData) {
                console.log('canSaveTryonData is false, return');
                alert('试戴位置未变化，无需保存');
                return;
            }

            this.saveTryonDataToServer();

        };
        this.saveButton = button;
        this.bottom_bar.appendChild(this.saveButton);

        return button;
    }

    hideSaveButton() {
        if (this.saveButton)
            this.saveButton.style.display = 'none';
    }

    showSaveButton() {
        if (this.saveButton)
            this.saveButton.style.display = 'flex';
    }

    //添加拍照按钮
    addCameraButton() {
        // let createCameraButton = () => {
        //     //创建dom
        //     let wrap_div = document.createElement('div');
        //     wrap_div.classList.add("button", "btn-camera");
        //     wrap_div.setAttribute("id", "cameraButton");
        //     return wrap_div;
        // }

        // let button = createCameraButton();
        // button.title = '图片';

        // button.onclick = () => {
        //     console.log("点击拍照事件");
        //     this.loadFile();
        // };
        // this.cameraButton = button;
        // this.bottom_bar.appendChild(button);

        // return button;
    }

    //添加预览按钮
    // addPreviewButton() {
    //     let createEyeButton = () => {
    //         //创建dom
    //         let wrap_div = document.createElement('div');
    //         wrap_div.classList.add("button", "btn-prev");
    //         wrap_div.setAttribute("id", "previewButton");
    //         return wrap_div;
    //     }

    //     let button = createEyeButton();
    //     return button;
    // }

    //添加截屏按钮
    addScreenshotButton() {
        let createScreenshotButton = () => {
            //创建dom
            let wrap_div = document.createElement('div');
            wrap_div.classList.add("button", "btn-screenshot");
            wrap_div.setAttribute("id", "screenshotButton");
            return wrap_div;
        }

        let button = createScreenshotButton();
        button.title = '截屏';
        return button;
    }

    //添加左旋转按钮
    addRotateLeftButton() {
        let createRotateLeftButton = () => {
            //创建dom
            let wrap_div = document.createElement('div');
            wrap_div.classList.add("button", "btn-rotate-left");
            wrap_div.setAttribute("id", "rotateLeftButton");
            return wrap_div;
        }

        let button = createRotateLeftButton();
        button.title = '左旋转';

        button.onclick = () => {
            console.log("点击左旋转事件");
            this.rotateTryonImage(90);
        };
        this.rotateLeftButton = button;
        this.right_bar.appendChild(button);

        return button;
    }

    //添加右旋转按钮
    addRotateRightButton() {
        let createRotateRightButton = () => {
            //创建dom
            let wrap_div = document.createElement('div');
            wrap_div.classList.add("button", "btn-rotate-right");
            wrap_div.setAttribute("id", "rotateRightButton");
            return wrap_div;
        }

        let button = createRotateRightButton();
        button.title = '右旋转';

        button.onclick = () => {
            console.log("点击右旋转事件");
            this.rotateTryonImage(-90);
        };
        this.rotateRightButton = button;
        this.right_bar.appendChild(button);

        return button;
    }

    //添加分享按钮
    addShareButton() {
        let createShareButton = () => {
            //创建dom
            let wrap_div = document.createElement('div');
            wrap_div.classList.add("button", "btn-share");
            wrap_div.setAttribute("id", "shareButton");
            return wrap_div;
        }

        let button = createShareButton();
        button.title = '分享';

        button.onclick = () => {
            console.log("点击分享事件");
            if (this.browser.isPC) {
                this.doScreenshot();
                // doScreenshotAndQiniuUpload(function(url){
                //     if (option.onShareButtonClick)
                //         option.onShareButtonClick(url);
                // });
            } else if (this.browser.isWeixin) {
                this.doScreenshotAndQiniuUpload(function(url) {
                    if (this.options.onShareButtonClick)
                        this.options.onShareButtonClick(url);
                });
            }
        };
        this.shareButton = button;
        this.bottom_bar.appendChild(button);

        return button;
    }

    //添加页面返回按钮
    addBackButton() {
        let createBackButton = () => {
            //创建dom
            let wrap_div = document.createElement('div');
            wrap_div.classList.add("button", "btn-back");
            wrap_div.setAttribute("id", "backButton");
            return wrap_div;
        }

        let button = createBackButton();
        button.title = '返回';

        button.onclick = () => {
            console.log("点击返回事件");
            if (this.options.onBackButtonClick)
                this.options.onBackButtonClick();
            else
                window.history.back();
        };
        this.backButton = button;
        this.bottom_bar.appendChild(button);

        return button;
    }

    getProductDetail(onFinished, onFailed) {
        axios.get(this.getProductDetailUrl, {
            params: {
                id: this.productId
            }
        }).then((response) => {
            console.log('getProductDetail: ', response);
            if (response.data.code === 10200) {
                if (onFinished)
                    onFinished(response.data.data);
            } else {
                if (onFailed)
                    onFailed(response.message);
            }
        }).catch((error) => {
            console.error(error);
            if (onFailed)
                onFailed(error);
        });
    }

    updateProductTryonDatas(onFinished, onFailed) {
        this.tryOnData = [];
        for (let key in this.tryOnDataDict) {
            let value = this.tryOnDataDict[key];
            this.tryOnData.push({
                key: key,
                url: value,
            });
        }
        console.log('updateTryonDatas: ', this.tryOnData);
        axios.post(this.updateProductDetailUrl, {
            id: this.productId,
            tryOnData: this.tryOnData
        }, {
            headers: {
                'Authorization': this.loginToken
            }
        }).then((response) => {
            console.log('updateProductTryonDatas: ', response);
            if (response.data.code === 10200) {
                if (onFinished)
                    onFinished(response.data);
            } else {
                if (onFailed)
                    onFailed(response.message);
            }
        }).catch((error) => {
            console.error(error);
            if (onFailed)
                onFailed(error);
        });
    }

    ensureLocalStorageKey() {
        // console.log('window.location:', window.location);
        this.localStorageKey = window.location.href;
        if (!this.localStorageKey.match('category') && this.category)
            this.localStorageKey += '&category=' + this.category;
        if (!this.localStorageKey.match('userId') && this.userId)
            this.localStorageKey += '&userId=' + this.userId;
        // console.log('ensureLocalStorageKey: ', this.localStorageKey);
    }

    onProgress(value) {
        // console.log('onProgress: ', value, typeof(value));
        if (value.lengthComputable) {
            let progress = value.loaded / value.total;
            this.showLoadingProgress(progress);
        } else if (typeof(value) === 'number') {
            let progress = value;
            this.showLoadingProgress(progress);
        }
    }

    onError(error) {
        console.error('onError ', error);
        alert('Error: ' + error.toString());
        this.hideLoadingProgress();
    }

    loadImageFromUrl(url) {
        console.log('loadImageFromUrl: ', url);
        this.showLoadingProgress(0);

        // instantiate a loader
        let loader = new THREE.TextureLoader();
        loader.setCrossOrigin('*');

        // load a resource
        loader.load(url, (texture) => {
            // console.log("loaded " + texture.image +" size " + texture.image.width + "x" + texture.image.height);

            this.hideLoadingProgress();
            texture.url = url;
            this.updateTryonImage(texture);
            this.resetAllTryonObjectInAdapterScreen();
            // this.showSaveButton();
            this.changeSelectedTryonImageButton(null);
            this.canSaveTryonData = true;

        }, this.onProgress, this.onError);

    }

    ensureObjectSize(object, limitSize) {
        object.scale.set(1, 1, 1);
        let box3 = new THREE.Box3();
        box3.setFromObject(object);
        let size = new THREE.Vector3();
        box3.getSize(size);
        let xRadio = limitSize / size.x;
        let yRadio = limitSize / size.y;
        // let zRadio = limitSize / size.z;
        let radio = Math.min(xRadio, yRadio);
        // console.log('ensureObjectSize: ', size, radio);
        object.scale.set(radio, radio, radio);
        // let center = new THREE.Vector3();
        // box3.getCenter(center);
        // //TODO
    }

    addTryonObject(object, onFinished) {
        let tryonType = object.tryonType || object.userData.tryonType;
        if (!tryonType)
            tryonType = '单戒';
        console.log('addTryonObject: ', object);
        if (tryonType.match('吊坠') && !object.isChain) {
            this.showLoadingProgress(0);
            let url = 'res/chain.png';
            if (this.OnlineMode) {
                url = this.baseUrl + this.baseDir + url;
            }
            let loader = new THREE.TextureLoader();
            loader.setCrossOrigin('*');
            let texture = loader.load(url);
            url = 'res/chain.FBX';
            if (this.OnlineMode) {
                url = this.baseUrl + this.baseDir + url;
            }
            loader = new THREE.GT3DLoader();
            // loader.setCrossOrigin('*');
            loader.load(url, (result) => {
                result.traverse((child) => {
                    if (child.material) {
                        child.material.map = texture;
                        child.material.alphaMap = null;
                        child.material.needsUpdate = true;
                    }
                    if (child.name === 'joint1') {
                        this.chainLeftJointPosition = child.position.clone();
                        // console.log('chainLeftJointPosition: ', chainLeftJointPosition);
                    } else if (child.name === 'joint3') {
                        this.chainRightJointPosition = child.position.clone();
                        // console.log('chainRightJointPosition: ', chainRightJointPosition);
                    }
                });
                this.hideLoadingProgress();
                let chainObject = new THREE.Object3D();
                this.ensureObjectSize(result, this.necklaceObjectSize);
                chainObject.add(result);
                result.position.set(0, 0, 20);
                this.ensureObjectSize(object, this.pendantObjectSize);
                chainObject.add(object);
                object.position.set(-2.5, -140, 20);
                chainObject.userData.tryonType = '吊坠';
                chainObject.userData.isTryonObject = true;
                chainObject.isChain = true;
                // console.log(result);
                this.addTryonObject(chainObject, onFinished);
            }, this.onProgress, this.onError);
            return;
        }
        object.position.set(0, 0, 0);
        object.rotation.set(0, 0, 0);
        object.scale.set(1, 1, 1);
        object.traverse((child) => {
            if (child instanceof THREE.Mesh)
                child.castShadow = true;
        });

        this.ensureObjectSize(object, this.tryonObjectSize);

        let geometry;
        if (tryonType.match('项链') || tryonType.match('吊坠')) {
            geometry = new THREE.BoxBufferGeometry(this.necklaceObjectSize, this.necklaceObjectSize, this.necklaceObjectSize);
        } else {
            geometry = new THREE.BoxBufferGeometry(this.tryonObjectBoxSize, this.tryonObjectBoxSize, this.tryonObjectBoxSize);
        }
        let material = new THREE.MeshBasicMaterial({
            opacity: 0,
            alphaTest: 0.5
        });
        let box = new THREE.Mesh(geometry, material);
        box.name = "tryonObject:" + object.name;
        // box.material.opacity = 0;
        // box.material.transparent = true;
        // box.material.needsUpdate = true;
        // var box = new THREE.Object3D();
        box.tryonType = tryonType;

        box.add(object);
        if (tryonType.match('项链') || tryonType.match('吊坠')) {
            object.scale.multiplyScalar(this.necklaceObjectSize / this.tryonObjectBoxSize);
            if (tryonType.match('项链'))
                box.position.set(0, 0, 1);
            else
                box.position.set(0, 0, 0);
            // this.directionalLight.shadow.bias = 0;
        } else if (tryonType.match('胸针')) {
            box.position.set(0, 0, 100);
            // this.directionalLight.shadow.bias = 0;
        } else if (tryonType.match('女戒')) {
            object.rotation.set(THREE.Math.degToRad(90), 0, 0);
            box.position.set(this.tryonObjectBoxSize / 2, 0, 0);
        } else if (tryonType.match('男戒')) {
            object.rotation.set(THREE.Math.degToRad(90), 0, 0);
            box.position.set(-this.tryonObjectBoxSize / 2, 0, 0);
        } else if (tryonType.match('耳环左')) {
            // object.rotation.set(THREE.Math.degToRad(90), 0, 0);
            box.position.set(this.tryonObjectBoxSize / 2, 0, 0);
            // this.directionalLight.shadow.bias = 0;
        } else if (tryonType.match('耳环右')) {
            // object.rotation.set(THREE.Math.degToRad(90), 0, 0);
            box.position.set(-this.tryonObjectBoxSize / 2, 0, 0);
            // this.directionalLight.shadow.bias = 0;
        } else {
            object.rotation.set(THREE.Math.degToRad(90), 0, 0);
        }

        this.tryonImagePlane.add(box);
        this.tryonObjectArray.push(box);

        // console.log('box: ', box);
        if (onFinished)
            onFinished();
    }

    checkAndAddTryonObjects(result, onFinished) {
        let tryonObjectFinded = false;
        if (result instanceof THREE.Scene) {
            let count = 0;
            let finishedCount = 0;
            while (result.children !== null && result.children.length > 0) {
                var child = result.children.pop();
                if (child.isLight)
                    continue;
                let name = child.name.toLowerCase();
                if (child.isTryonObject || child.userData.isTryonObject) {
                    count++;
                    this.addTryonObject(child, () => {
                        finishedCount++;
                        if (count === finishedCount && onFinished) {
                            onFinished();
                        }
                    });
                    tryonObjectFinded = true;
                } else {
                    console.warn('the object unfinded tryon tag, ', child);
                    this.objectGroup.add(child);
                }
            }
        } else {
            let name = result.name.toLowerCase();
            if (result.isTryonObject || result.userData.isTryonObject) {
                this.addTryonObject(result, onFinished);
                tryonObjectFinded = true;
            } else {
                console.warn('the object unfinded tryon tag, ', result);
                this.objectGroup.add(result);
            }
        }
        // console.log('scene: ', this.scene);
        if (!tryonObjectFinded) {
            alert('未发现可试戴对象，请返回编辑器检查场景。');
        }
    }

    getTryonSamples(onFinished) {
        return new Promise((resolve, reject) => {
            if (this.tryonSamples) {
                if (onFinished)
                    onFinished(this.tryonSamples);
                resolve(this.tryonSamples);
                return;
            }
            let url = 'res/samples.json';
            if (this.OnlineMode) {
                url = this.baseUrl + this.baseDir + url;
            }
            let loader = new THREE.FileLoader();
            loader.load(url, (text) => {
                this.tryonSamples = JSON.parse(text);
                // console.log('loadTryonSamples: ', this.tryonSamples);
                if (onFinished)
                    onFinished(this.tryonSamples);
                resolve(this.tryonSamples);
            }, undefined, (error) => {
                console.error(error);
                alert('获取公共模板数据失败，请刷新重试');
                reject();
            });
        });
    }

    createTryonImageButtons() {
        let iconUrl, dataUrl, key;
        let samples = this.tryonSamples[this.category];
        // console.log('samples: ', samples);
        if (samples) {
            for (let i = 0; i < samples.length; i++) {
                let sample = samples[i];
                key = sample.data;
                iconUrl = sample.icon;
                let isCustom = false;
                if (this.tryOnDataDict && this.tryOnDataDict[key]) {
                    dataUrl = this.tryOnDataDict[key];
                    isCustom = true;
                } else
                    dataUrl = sample.data;
                this.addTryonImageButton(iconUrl, dataUrl, key).isCustom = isCustom;
            }
            key = this.customKey;
            iconUrl = this.customIcon;
            if (this.tryOnDataDict && this.tryOnDataDict[key]) {
                dataUrl = this.tryOnDataDict[key];
                this.customButton = this.addTryonImageButton(iconUrl, dataUrl, key);
                this.customButton.isCustom = true;
                // console.log('customButton: ', this.customButton);
            }
        } else {
            alert("未发现可试戴类型，请返回检查产品类型。");
        }
    }

    addTryonImageButton(iconUrl, dataUrl, key) {
        // console.log('addTryonImageButton: ', iconUrl, dataUrl, key);
        if (!iconUrl.startsWith('http') && this.OnlineMode) {
            iconUrl = this.baseUrl + this.baseDir + iconUrl;
        }
        let btn = this.addBackgroundButton(iconUrl, dataUrl, key);
        btn.onclick = () => {
            // console.log('onclick: ', this);
            this.changeSelectedTryonImageButton(btn);
        };
        this.tryonImageButtons.push(btn);
        return btn;
    }

    changeSelectedTryonImageButton(selection) {
        // console.log('changeSelectedTryonImageButton: ', selection);
        this.selectedTryonImageButton = selection;
        for (let i = 0; i < this.tryonImageButtons.length; i++) {
            let btn = this.tryonImageButtons[i];
            if (btn === selection) {
                btn.classList.add("borbtn-active");

                let key = btn.key;
                let url = btn.dataUrl; //getAttribute('id');
                if (!url.startsWith('http') && this.OnlineMode) {
                    url = this.baseUrl + this.baseDir + url;
                }
                this.loadTryonDataFromUrl(url);
                // if (!this.DebugMode)
                //     this.hideSaveButton();
                if (this.loginToken) {
                    this.showSaveButton();
                    if (selection.isCustom)
                        this.showRemoveButton();
                    else
                        this.hideRemoveButton();
                } else {
                    this.hideSaveButton();
                    this.hideRemoveButton();
                }
                if (this.DebugMode)
                    this.showSaveButton();
                this.canSaveTryonData = false;
                // }
            } else {
                btn.classList.remove("borbtn-active");
            }
        }
    }

    changeSelectedTryonImageButtonByIndex(index) {
        var btn = this.tryonImageButtons[index];
        if (btn)
            this.changeSelectedTryonImageButton(btn);
    }

    indexOfTryonImageButton(btn) {
        for (let i = 0; i < this.tryonImageButtons.length; i++) {
            if (this.tryonImageButtons[i] === btn)
                return i;
        }
        return -1;
    }

    removeTryonImageButton(btn) {
        btn.parentNode.removeChild(btn);
        var index = this.indexOfTryonImageButton(btn);
        this.tryonImageButtons.splice(index, 1);
    }

    removeSelectedTryonImageButton() {
        if (this.selectedTryonImageButton)
            this.removeTryonImageButton(this.selectedTryonImageButton);
        if (this.tryonImageButtons.length > 0) {
            var btn = this.tryonImageButtons[0];
            this.changeSelectedTryonImageButton(btn);
        } else {
            this.selectedTryonImageButton = null;
            this.clearTryonImage();
        }
    }

    startLoadScene() {
        let loadScene = (resolve, reject) => {
            if (this.modelPath === undefined) {
                console.warn('the modelPath is undefined.');
                alert('未发现可试戴模型，请返回编辑器检查场景。');
                reject();
                return;
            }
            let url = this.modelPath;
            if (!url.startsWith('http'))
                url = this.baseUrl + '/models/' + this.modelPath + '.gt3d';
            super.loadScene(url, (result) => {
                this.hideLoadingProgress();
                // loadTryonDataFromLocalStorage();
                // this.createTryonImageButtons();
                this.changeSelectedTryonImageButtonByIndex(0);
                resolve();
            }, this.onProgress, this.onError);
        };

        let parseDetailData = (data, resolve, reject) => {
            // this.productDetail = data;
            this.productId = data.id;
            this.userId = data.userId;
            this.modelPath = data.modelId;
            this.category = data.type;
            this.tryOnData = data.tryOnData;
            this.tryOnDataDict = {};
            if (this.tryOnData && this.tryOnData.length > 0) {
                for (let i = this.tryOnData.length - 1; i >= 0; i--) {
                    let data = this.tryOnData[i];
                    this.tryOnDataDict[data.key] = data.url;
                }
            }
            console.log('tryOnDataDict: ', this.tryOnDataDict);
            this.customKey = this.userId + '_' + this.productId + '_custom.json';
            loadScene(resolve, reject);
        };

        return new Promise((resolve, reject) => {
            if (this.productDetail) {
                parseDetailData(this.productDetail, resolve, reject);
            } else if (this.productId) {
                this.getProductDetail((data) => {
                    parseDetailData(data, resolve, reject);
                }, (error) => {
                    alert(error);
                    reject();
                });
            } else {
                alert('作品id为空');
                // loadScene(resolve, reject);
            }
        });
    }

    parseResult(result) {
        return new Promise((resolve, reject) => {
            // console.log('parseResult:', result);
            if (!this.category && result.userData.category) {
                this.category = result.userData.category;
            }
            if (!this.category)
                this.category = '未知';
            // this.ensureLocalStorageKey();
            // this.createTryonImageButtons();
            this.checkAndAddTryonObjects(result);
            // resolve();
            this.getTryonSamples().then(() => {
                this.createTryonImageButtons();
                resolve();
            });
        });
    }

    readTryonData(data) {
        // console.log('readTryonData: ', data);
        if (!data)
            return;

        let evaluationTryonObjects = () => {
            if (data.objectList && data.objectList.length > 0) {
                if (data.objectList.length === 1) {
                    let dataObj = data.objectList[0];
                    for (let i = 0; i < this.tryonObjectArray.length; i++) {
                        let tryonObj = this.tryonObjectArray[i];
                        evaluationTryonObject(dataObj, tryonObj);
                    }
                } else {
                    for (let i = 0; i < this.tryonObjectArray.length; i++) {
                        let tryonObj = this.tryonObjectArray[i];
                        let tryonType = tryonObj.tryonType || tryonObject.userData.tryonType;
                        if (tryonType) {
                            for (let j = 0; j < data.objectList.length; j++) {
                                let dataObj = data.objectList[j];
                                if (dataObj.tryonType === tryonType) {
                                    evaluationTryonObject(dataObj, tryonObj);
                                    break;
                                }
                            }
                        } else {
                            var dataObj = data.objectList[i];
                            if (dataObj)
                                evaluationTryonObject(dataObj, tryonObj);
                        }
                    }
                }
            }
        }

        let evaluationTryonObject = (dataObj, tryonObj) => {
            // console.log('evaluationTryonObject: ', dataObj, tryonObj);
            let position = dataObj.position;
            tryonObj.position.set(position.x, position.y, position.z);
            let rotation = dataObj.rotation;
            tryonObj.rotation.setFromVector3(new THREE.Vector3(rotation.x, rotation.y, rotation.z));
            let scale = dataObj.scale;
            tryonObj.scale.set(scale.x, scale.y, scale.z);
            if (dataObj.leftJointX && dataObj.rightJointX) {
                tryonObj.traverse((child) => {
                    if (child.name === 'joint1') {
                        child.position.x = dataObj.leftJointX;
                    } else if (child.name === 'joint3') {
                        child.position.x = dataObj.rightJointX;
                    }
                });
            }
            if (dataObj.visible !== undefined)
                tryonObj.visible = dataObj.visible;
            else
                tryonObj.visible = true;
            // console.log('evaluationTryonObject: ', dataObj, tryonObj);
        }

        if (data.tryonImage && data.tryonImage.url) {
            // console.log('loadTryonImage: ', data.tryonImage.url);
            // showLoadingProgress(0);
            let loader = new THREE.TextureLoader();
            loader.setCrossOrigin('*');
            let url = data.tryonImage.url;
            loader.load(url, (texture) => {
                // hideLoadingProgress();
                if (url.startsWith('http'))
                    texture.url = url;
                this.updateTryonImage(texture, data.tryonImage.orientation);
                evaluationTryonObjects();
                this.canSaveTryonData = false;
            }, null, this.onError);
        } else {
            evaluationTryonObjects();
        }
        this.canSaveTryonData = false;
    }

    loadTryonDataFromLocalStorage() {
        let json = this.readFromLocalStorage(this.localStorageKey);
        // console.log('loadTryonDataFromLocalStorage: ', localStorageKey, json);
        if (json) {
            let data = JSON.parse(json);
            this.readTryonData(data);
        } else {
            console.warn('unsaved data in ' + this.localStorageKey);
        }
    }

    loadTryonDataFromUrl(url) {
        console.log('loadTryonDataFromUrl: ', url);
        this.showLoadingProgress(0);
        let loader = new THREE.FileLoader();
        loader.load(url, (text) => {
            this.hideLoadingProgress();
            // console.log(text);
            let data = JSON.parse(text);
            this.readTryonData(data);
        }, this.onProgress, this.onError);
    }

    removeTryonObject(object) {
        if (object == null)
            return;
        // console.log("removeTryonObject: " + object.name);
        this.hideTryonObjectControlMenu();
        this.tryonImagePlane.remove(object);
        for (let i = this.tryonObjectArray.length - 1; i >= 0; i--) {
            if (this.tryonObjectArray[i] == object) {
                this.tryonObjectArray.splice(i, 1);
                break;
            }
        }
        // console.log(tryonObjectArray);
    }

    hideTryonObject(object) {
        if (object == null)
            return;
        // console.log("hideTryonObject: " + object.name);
        this.hideTryonObjectControlMenu();
        object.visible = false;
    }

    showTryonObject(object) {
        if (object == null)
            return;
        // console.log("showTryonObject: " + object.name);
        this.hideTryonObjectControlMenu();
        object.visible = true;
    }

    resetObjectTransformProperties(object) {
        if (!object)
            return;
        // console.log("resetObjectTransformProperties: ", object);
        let tryonType = object.tryonType || object.userData.tryonType;
        if (tryonType && tryonType.match('项链'))
            position.set(0, 0, 1);
        else if (tryonType && tryonType.match('胸针'))
            object.position.set(0, 0, 100);
        else
            object.position.set(0, 0, 0);
        object.rotation.set(0, 0, 0);
        object.scale.set(1, 1, 1);
        this.canSaveTryonData = true;
    }

    resetTryonImageProperties() {
        this.resetObjectTransformProperties(this.tryonImageRoot);
    }

    resetTryonObjectInAdapterScreen(object) {
        this.resetObjectTransformProperties(object);
        let radio = this.tryonImagePlane.scale.x;
        // if (radio < 1) {
        let scale = 1 / radio;
        object.scale.set(scale, scale, scale);
        // }
    }

    resetAllTryonObjectInAdapterScreen() {
        for (let i = 0; i < this.tryonObjectArray.length; i++) {
            this.resetTryonObjectInAdapterScreen(this.tryonObjectArray[i]);
        }
    }

    createTryonObjectControlMenu(parent) {
        // var group = new THREE.Group();
        let loader = new THREE.TextureLoader();

        let realSize = Math.min(this.options.width, this.options.height);
        let radio = realSize / this.standardSize;
        let menuFrameSize = this.menuFrameSize * radio;
        let menuBtnSize = this.menuBtnSize * radio;
        // alert('frameSize: ' + menuFrameSize + ', btnSize: ' + menuBtnSize);
        let menuFrameWidth = menuFrameSize;
        let menuFrameHeight = menuFrameSize;
        let midMenuDistance = menuFrameSize / 2;

        let start = new THREE.Vector2(-menuFrameWidth / 2, -menuFrameHeight / 2);
        let end = new THREE.Vector2(menuFrameWidth / 2, menuFrameHeight / 2);
        let geometry = new THREE.Geometry();
        geometry.vertices.push(new THREE.Vector3(start.x, start.y, 0), new THREE.Vector3(end.x, start.y, 0), new THREE.Vector3(end.x, end.y, 0), new THREE.Vector3(start.x, end.y, 0), new THREE.Vector3(start.x, start.y, 0));

        let material = new THREE.LineBasicMaterial({
            color: 0xffffff,
            linewidth: 2
        });
        let menu_frame = new THREE.Line(geometry, material);
        menu_frame.name = "menu_frame";
        parent.add(menu_frame);
        menu_frame.position.set(0, 0, 1000);

        // var geometry = new THREE.PlaneBufferGeometry(menuFrameWidth, menuFrameHeight);
        // var material = new THREE.MeshBasicMaterial({
        //     transparent: true,
        //     opacity: 0,
        // });
        this.menu_frame_plane = new THREE.Mesh(
            new THREE.PlaneBufferGeometry(menuFrameWidth, menuFrameHeight),
            new THREE.MeshBasicMaterial({
                transparent: true,
                opacity: 0,
            }));
        this.menu_frame_plane.name = 'menu_frame_plane';
        menu_frame.add(this.menu_frame_plane);

        let url = "res/btn_reset.png";
        if (this.OnlineMode) {
            url = this.baseUrl + this.baseDir + url;
        }
        loader.load(url, (map) => {
            map.minFilter = THREE.LinearFilter;
            map.generateMipmaps = false;
            geometry = new THREE.PlaneBufferGeometry(menuBtnSize, menuBtnSize);
            material = new THREE.MeshBasicMaterial({
                map: map,
                color: 0xffffff,
                side: THREE.FrontSide,
                transparent: true
            });
            this.btn_reset = new THREE.Mesh(geometry, material);
            this.btn_reset.isButton = true;
            this.btn_reset.name = "btn_reset";
            menu_frame.add(this.btn_reset);
            this.btn_reset.position.set(-menuFrameWidth / 2, menuFrameHeight / 2, 1);
        }, null, this.onError);

        url = "res/btn_zrotate.png";
        if (this.OnlineMode) {
            url = this.baseUrl + this.baseDir + url;
        }
        loader.load(url, (map) => {
            map.minFilter = THREE.LinearFilter;
            map.generateMipmaps = false;
            geometry = new THREE.PlaneBufferGeometry(menuBtnSize, menuBtnSize);
            material = new THREE.MeshBasicMaterial({
                map: map,
                color: 0xffffff,
                side: THREE.FrontSide,
                transparent: true
            });
            this.btn_zrotate = new THREE.Mesh(geometry, material);
            this.btn_zrotate.isButton = true;
            this.btn_zrotate.name = "btn_zrotate";
            menu_frame.add(this.btn_zrotate);
            this.btn_zrotate.position.set(-menuFrameWidth / 2, -menuFrameHeight / 2, 1);
        }, null, this.onError);

        url = "res/btn_scale.png";
        if (this.OnlineMode) {
            url = this.baseUrl + this.baseDir + url;
        }
        loader.load(url, (map) => {
            map.minFilter = THREE.LinearFilter;
            map.generateMipmaps = false;
            geometry = new THREE.PlaneBufferGeometry(menuBtnSize, menuBtnSize);
            material = new THREE.MeshBasicMaterial({
                map: map,
                color: 0xffffff,
                side: THREE.FrontSide,
                transparent: true
            });
            this.btn_scale = new THREE.Mesh(geometry, material);
            this.btn_scale.isButton = true;
            this.btn_scale.name = "btn_scale";
            menu_frame.add(this.btn_scale);
            this.btn_scale.position.set(menuFrameWidth / 2, menuFrameHeight / 2, 1);
        }, null, this.onError);

        url = "res/btn_xyrotate.png";
        if (this.OnlineMode) {
            url = this.baseUrl + this.baseDir + url;
        }
        loader.load(url, (map) => {
            map.minFilter = THREE.LinearFilter;
            map.generateMipmaps = false;
            geometry = new THREE.PlaneBufferGeometry(menuBtnSize, menuBtnSize);
            material = new THREE.MeshBasicMaterial({
                map: map,
                color: 0xffffff,
                side: THREE.FrontSide,
                transparent: true
            });
            this.btn_xyrotate = new THREE.Mesh(geometry, material);
            this.btn_xyrotate.isButton = true;
            this.btn_xyrotate.name = "btn_xyrotate";
            menu_frame.add(this.btn_xyrotate);
            this.btn_xyrotate.position.set(menuFrameWidth / 2, -menuFrameHeight / 2, 1);
        }, null, this.onError);

        url = "res/btn_expand.png";
        if (this.OnlineMode) {
            url = this.baseUrl + this.baseDir + url;
        }
        loader.load(url, (map) => {
            map.minFilter = THREE.LinearFilter;
            map.generateMipmaps = false;
            geometry = new THREE.PlaneBufferGeometry(menuBtnSize, menuBtnSize);
            material = new THREE.MeshBasicMaterial({
                map: map,
                color: 0xffffff,
                side: THREE.FrontSide,
                transparent: true
            });
            this.btn_expand = new THREE.Mesh(geometry, material);
            this.btn_expand.isButton = true;
            this.btn_expand.name = "btn_expand";
            menu_frame.add(this.btn_expand);
            this.btn_expand.position.set(menuFrameWidth / 2, -menuFrameHeight / 2, 1);
        }, null, this.onError);

        // url = "res/btn_move.png";
        // if (OnlineMode) {
        //     url = baseUrl + baseDir + url;
        // }
        // map = loader.load(url, function (map) {
        //     map.minFilter = THREE.LinearFilter;
        //     geometry = new THREE.PlaneBufferGeometry(menuBtnSize, menuBtnSize);
        //     material = new THREE.MeshBasicMaterial({
        //         map: map,
        //         color: 0xffffff,
        //         side: THREE.FrontSide,
        //         transparent: true
        //     });
        //     btn_move = new THREE.Mesh(geometry, material);
        //     btn_move.isButton = true;
        //     btn_move.name = "btn_move";
        //     menu_frame.add(btn_move);
        //     btn_move.position.set(menuFrameWidth / 2, -menuFrameHeight / 2, 1);
        // }, null, onError);

        url = "res/btn_delete.png";
        if (this.OnlineMode) {
            url = this.baseUrl + this.baseDir + url;
        }
        loader.load(url, (map) => {
            map.minFilter = THREE.LinearFilter;
            map.generateMipmaps = false;
            geometry = new THREE.PlaneBufferGeometry(menuBtnSize, menuBtnSize);
            material = new THREE.MeshBasicMaterial({
                map: map,
                color: 0xffffff,
                side: THREE.FrontSide,
                transparent: true
            });
            this.btn_delete = new THREE.Mesh(geometry, material);
            this.btn_delete.isButton = true;
            this.btn_delete.name = "btn_delete";
            menu_frame.add(this.btn_delete);
            this.btn_delete.position.set(0, -menuFrameHeight / 2, 1);
        }, null, this.onError);

        this.btn_submenu = new THREE.Mesh();
        this.btn_submenu.isButton = true;
        url = "res/btn_submenu.png";
        if (this.OnlineMode) {
            url = this.baseUrl + this.baseDir + url;
        }
        loader.load(url, (map) => {
            map.minFilter = THREE.LinearFilter;
            map.generateMipmaps = false;
            geometry = new THREE.PlaneBufferGeometry(menuBtnSize, menuBtnSize);
            material = new THREE.MeshBasicMaterial({
                map: map,
                color: 0xffffff,
                side: THREE.FrontSide,
                transparent: true
            });
            this.btn_submenu.geometry = geometry;
            this.btn_submenu.material = material;
            this.btn_submenu.name = "btn_submenu";
            menu_frame.add(this.btn_submenu);
            this.btn_submenu.position.set(0, menuFrameHeight / 2, 1);
        }, null, this.onError);

        this.tryonObjectControlSubMenu = new THREE.Group();
        this.tryonObjectControlSubMenu.name = "tryonObjectControlSubMenu";
        menu_frame.add(this.tryonObjectControlSubMenu);
        this.tryonObjectControlSubMenu.position.set(0, menuFrameHeight / 2, 1);

        url = "res/btn_close.png";
        if (this.OnlineMode) {
            url = this.baseUrl + this.baseDir + url;
        }
        loader.load(url, (map) => {
            map.minFilter = THREE.LinearFilter;
            map.generateMipmaps = false;
            geometry = new THREE.PlaneBufferGeometry(menuBtnSize, menuBtnSize);
            material = new THREE.MeshBasicMaterial({
                map: map,
                color: 0xffffff,
                side: THREE.FrontSide,
                transparent: true
            });
            this.btn_close = new THREE.Mesh(geometry, material);
            this.btn_close.isButton = true;
            this.btn_close.name = "btn_close";
            this.tryonObjectControlSubMenu.add(this.btn_close);
            this.btn_close.position.set(0, 0, 1);
        }, null, this.onError);

        var xPos = Math.sin(THREE.Math.degToRad(30)) * midMenuDistance;
        var yPos = Math.cos(THREE.Math.degToRad(30)) * midMenuDistance;

        url = "res/btn_shrink.png";
        if (this.OnlineMode) {
            url = this.baseUrl + this.baseDir + url;
        }
        loader.load(url, (map) => {
            map.minFilter = THREE.LinearFilter;
            map.generateMipmaps = false;
            geometry = new THREE.PlaneBufferGeometry(menuBtnSize, menuBtnSize);
            material = new THREE.MeshBasicMaterial({
                map: map,
                color: 0xffffff,
                side: THREE.FrontSide,
                transparent: true
            });
            this.btn_shrink = new THREE.Mesh(geometry, material);
            this.btn_shrink.isButton = true;
            this.btn_shrink.name = "btn_shrink";
            this.tryonObjectControlSubMenu.add(this.btn_shrink);
            this.btn_shrink.position.set(-xPos, yPos, 1);
        }, null, this.onError);

        // url = "res/btn_expand.png";
        // if (OnlineMode) {
        //     url = baseUrl + baseDir + url;
        // }
        // loader.load(url, function (map) {
        //     map.minFilter = THREE.LinearFilter;
        //     geometry = new THREE.PlaneBufferGeometry(menuBtnSize, menuBtnSize);
        //     material = new THREE.MeshBasicMaterial({
        //         map: map,
        //         color: 0xffffff,
        //         side: THREE.FrontSide,
        //         transparent: true
        //     });
        //     btn_expand = new THREE.Mesh(geometry, material);
        //     btn_expand.isButton = true;
        //     btn_expand.name = "btn_expand";
        //     tryonObjectControlSubMenu.add(btn_expand);
        //     btn_expand.position.set(xPos, yPos, 1);
        // }, null, onError);

        this.tryonObjectControlMenu = menu_frame;
        this.hideTryonObjectControlMenu();
        // parent.add(group);
    }

    hideTryonObjectControlMenu() {
        if (!this.tryonObjectControlMenu)
            return;
        this.action = ACTION.None;
        // hideTryonObjectControlSubMenu();
        this.tryonObjectControlMenu.visible = false;
    }

    bindTryonObjectControlMenuProperties(object) {
        if (!object || !this.tryonObjectControlMenu || !this.tryonObjectControlMenu.visible)
            return;
        // console.log("bindTryonObjectControlMenuProperties");
        // console.log(object);
        let position = object.getWorldPosition(new THREE.Vector3());
        // console.log(position);
        this.tryonObjectControlMenu.position.x = position.x;
        this.tryonObjectControlMenu.position.y = position.y;
        let scale = object.getWorldScale(new THREE.Vector3()).x;
        if (scale < this.menuMinScale)
            scale = this.menuMinScale;
        else if (scale > this.menuMaxScale)
            scale = this.menuMaxScale;
        // console.log(scale);
        this.tryonObjectControlMenu.scale.set(scale, scale, scale);
        // let rotation = object.getWorldQuaternion();
        let rotation = new THREE.Euler();
        rotation.setFromQuaternion(object.getWorldQuaternion(new THREE.Quaternion()));
        // console.log(rotation);
        this.tryonObjectControlMenu.rotation.z = rotation.z;
        // tryonObjectControlMenu.updateMatrixWorld(true);
        let btnScale = 1 / scale;
        this.tryonObjectControlMenu.traverse((child) => {
            if (child.isButton) {
                child.scale.set(btnScale, btnScale, btnScale);
            }
        });
    }

    showTryonObjectControlMenu(object) {
        if (!this.tryonObjectControlMenu || !object)
            return;
        this.tryonObjectControlMenu.visible = true;
        this.hideTryonObjectControlSubMenu();
        this.btn_submenu.visible = false;
        let tryonType = object.tryonType || object.userData.tryonType;
        if (tryonType === '吊坠') {
            // btn_submenu.visible = true;
            this.btn_expand.visible = true;
            this.btn_xyrotate.visible = false;
        } else {
            // btn_submenu.visible = false;
            this.btn_expand.visible = false;
            this.btn_xyrotate.visible = true;
        }
        if (tryonType === '耳环')
            this.btn_delete.visible = true;
        else
            this.btn_delete.visible = false;
        this.bindTryonObjectControlMenuProperties(object);
    }

    hideTryonObjectControlSubMenu() {
        if (!this.tryonObjectControlSubMenu)
            return;
        this.tryonObjectControlSubMenu.visible = false;
        this.btn_submenu.visible = true;
    }

    showTryonObjectControlSubMenu() {
        if (!this.tryonObjectControlSubMenu)
            return;
        this.tryonObjectControlSubMenu.visible = true;
        this.btn_submenu.visible = false;
    }

    clearTryonImage() {
        this.resetTryonImageProperties();

        this.tryonImageWidth = this.options.width;
        this.tryonImageHeight = this.options.height;
        if (this.tryonImagePlane.geometry)
            this.tryonImagePlane.geometry.dispose();
        this.tryonImagePlane.geometry = new THREE.PlaneBufferGeometry(this.tryonImageWidth, this.tryonImageHeight);
        if (this.tryonImagePlane.material.map)
            this.tryonImagePlane.material.map.dispose();
        this.tryonImagePlane.material.map = null;
        this.tryonImagePlane.material.needsUpdate = true;

        this.adapterTryonImageScale();
    }

    updateTryonImage(texture, orientation) {
        // console.log('updateTryonImage: ', texture, orientation);
        texture.minFilter = THREE.LinearFilter;
        texture.needsUpdate = true;

        this.resetObjectTransformProperties(this.tryonImagePlane);

        this.tryonImageWidth = texture.image.width;
        this.tryonImageHeight = texture.image.height;
        if (this.tryonImagePlane.geometry)
            this.tryonImagePlane.geometry.dispose();
        this.tryonImagePlane.geometry = new THREE.PlaneBufferGeometry(this.tryonImageWidth, this.tryonImageHeight);
        if (this.tryonImagePlane.material.map)
            this.tryonImagePlane.material.map.dispose();
        this.tryonImagePlane.material.map = texture;
        this.tryonImagePlane.material.needsUpdate = true;

        if (orientation)
            this.rotateTryonImage(orientation);
        else
            this.adapterTryonImageScale();
    }

    adapterTryonImageScale() {
        this.resetTryonImageProperties();

        let width = this.options.width;
        let height = this.options.height;
        // console.log("adapterTryonImageScale: rectSize=" + rect.width + "x" + rect.height + "; tryonImageSize=" + tryonImageWidth +"x"+ tryonImageHeight);
        let xRadio, yRadio;
        let orientation = this.getTryonImageOrientation();
        console.log('tryonImage orientation: ', orientation);
        if (Math.abs(orientation % 180) < 10) {
            xRadio = width / this.tryonImageWidth;
            yRadio = height / this.tryonImageHeight;
        } else {
            xRadio = width / this.tryonImageHeight;
            yRadio = height / this.tryonImageWidth;
        }
        // console.log("adapterTryonImageScale: " + xRadio + "; " + yRadio);
        let radio;
        if (this.browser.isPC)
            radio = Math.min(xRadio, yRadio);
        else
            radio = Math.max(xRadio, yRadio);
        this.tryonImagePlane.scale.set(radio, radio, radio);
        // if (radio < 1)
        this.tryonObjectMinScale = this.tryonObjectScaleRange.x / radio;
        this.tryonObjectMaxScale = this.tryonObjectScaleRange.y / radio;
        // console.log('tryonObjectMaxScale: ', tryonObjectMaxScale);

        this.limitTryonImagePosition();
    }

    limitTryonImagePosition() {
        // console.log("limitTryonImagePosition begin");
        let box = new THREE.Box3();
        box.setFromObject(this.tryonImageRoot);
        let size = box.getSize();
        // console.log('tryonImage size: ', size);
        let imageWidth = size.x;
        let imageHeight = size.y;
        // console.log("imageWorldSize: " + imageWidth + "x" + imageHeight);
        let position = this.tryonImageRoot.getWorldPosition(new THREE.Vector3());
        // console.log(position);
        let left = position.x - imageWidth / 2;
        let right = position.x + imageWidth / 2;
        let top = position.y + imageHeight / 2;
        let bottom = position.y - imageHeight / 2;
        // console.log("image border: [" + left + ", " + right + ", " + top + ", " + bottom + "]");
        // console.log("camera border: [" + camera.left + ", " + camera.right + ", " + camera.top + ", " + camera.bottom + "]");
        let deltaX = 0,
            deltaY = 0;
        if (this.browser.isPC) {
            let viewWidth = this.camera.right - this.camera.left;
            let viewHeight = this.camera.top - this.camera.bottom;
            if (imageWidth < viewWidth) {
                this.tryonImageRoot.position.x = 0;
            } else {
                if (right < this.camera.right) {
                    deltaX = this.camera.right - right;
                } else if (left > this.camera.left) {
                    deltaX = this.camera.left - left;
                }
            }
            if (imageHeight < viewHeight) {
                this.tryonImageRoot.position.y = 0;
            } else {
                if (top < this.camera.top) {
                    deltaY = this.camera.top - top;
                } else if (bottom > this.camera.bottom) {
                    deltaY = this.camera.bottom - bottom;
                }
            }
        } else {
            if (left > this.camera.left || right < this.camera.right || top < this.camera.top || bottom > this.camera.bottom) {
                // console.log("image border: [" + left + ", " + right + ", " + top + ", " + bottom + "]");
                // console.log("camera border: [" + camera.left + ", " + camera.right + ", " + camera.top + ", " + camera.bottom + "]");

                if (right < this.camera.right) {
                    deltaX = this.camera.right - right;
                } else if (left > this.camera.left) {
                    deltaX = this.camera.left - left;
                }
                if (top < this.camera.top) {
                    deltaY = this.camera.top - top;
                } else if (bottom > this.camera.bottom) {
                    deltaY = this.camera.bottom - bottom;
                }
            }
        }
        // console.log("translate delta: " + deltaX + ", " + deltaY);
        if (deltaX != 0)
            this.tryonImageRoot.translateX(deltaX);
        if (deltaY != 0)
            this.tryonImageRoot.translateY(deltaY);

        // console.log("limitTryonImagePosition end");
    }

    rotateTryonImage(degrees) {
        this.tryonImagePlane.rotateZ(THREE.Math.degToRad(degrees));
        this.reviseTryonImageOrientation();
        this.adapterTryonImageScale();
    }

    reviseTryonImageOrientation() {
        let orientation = this.getTryonImageOrientation() % 360;
        if (Math.abs(orientation) < 10) {
            orientation = 0;
        } else if (Math.abs(-90 - orientation) < 10 || Math.abs(270 - orientation) < 10) {
            orientation = -90;
        } else if (Math.abs(-180 - orientation) < 10 || Math.abs(180 - orientation) < 10) {
            orientation = -180
        } else if (Math.abs(90 - orientation) < 10 || Math.abs(-270 - orientation) < 10) {
            orientation = 90;
        }
        this.tryonImagePlane.rotation.set(0, 0, THREE.Math.degToRad(orientation));
    }

    checkIsTryonObject(object) {
        while (true) {
            if (object === null || object === this.tryonImagePlane)
                return null;
            for (let i = 0; i < this.tryonObjectArray.length; i++) {
                if (object === this.tryonObjectArray[i]) {
                    // console.log('checkIsTryonObject: ', object);
                    // alert('checkIsTryonObject');
                    return object;
                }
            }
            object = object.parent;
        }
    }

    checkRaycastObject(clientX, clientY) {
        let raycastCoords = this.clientPosToNDC(clientX, clientY);
        this.raycaster.setFromCamera(raycastCoords, this.camera);
        let intersects = this.raycaster.intersectObjects(this.objectGroup.children, true);
        let selection;
        if (intersects.length > 0) {
            // console.log('intersects: ', intersects);
            selection = intersects[0].object;
        } else {
            selection = null;
        }
        console.log('checkRaycastObject: ', selection);
        // alert('checkRaycastObject: ' + selection.name);
        let tryonObj = this.checkIsTryonObject(selection);
        if (tryonObj != null) {
            this.selectedObject = tryonObj;
            this.showTryonObjectControlMenu(this.selectedObject);
            return;
        }
        if (selection === this.tryonObjectControlMenu || selection === this.menu_frame_plane) {
            this.action = ACTION.DragMove;
        } else if (selection === this.btn_xyrotate) {
            this.action = ACTION.DragXYRotate;
        } else if (selection === this.btn_scale) {
            this.action = ACTION.DragScale;
        } else if (selection === this.btn_zrotate) {
            this.action = ACTION.DragZRotate;
        } else if (selection === this.btn_shrink) {
            this.action = ACTION.DragShrink;
        } else if (selection === this.btn_expand) {
            this.action = ACTION.DragExpand;
        } else if (selection === this.btn_submenu) {
            this.showTryonObjectControlSubMenu();
        } else if (selection === this.btn_close) {
            this.hideTryonObjectControlSubMenu();
        } else if (selection === this.btn_reset) {
            this.resetTryonObjectInAdapterScreen(this.selectedObject);
            // hideTryonObjectControlSubMenu();
        } else if (selection === this.btn_delete) {
            this.hideTryonObject(this.selectedObject);
            this.selectedObject = null;
        } else {
            if (selection === this.tryonImagePlane)
                this.selectedObject = selection;
            this.hideTryonObjectControlMenu();
            return;
        }
        // console.log(action);
    }

    checkAction(clientX, clientY) {
        let raycastCoords = this.clientPosToNDC(clientX, clientY);
        this.raycaster.setFromCamera(raycastCoords, this.camera);
        let intersects = this.raycaster.intersectObjects(this.objectGroup.children, true);
        let selection;
        if (intersects.length > 0) {
            selection = intersects[0].object;
        } else {
            selection = null;
        }
        // console.log('checkAction: ', selection);
        if (selection === this.tryonObjectControlMenu || selection === this.menu_frame_plane || selection === this.tryonImagePlane) {
            this.action = ACTION.DragMove;
        } else if (selection === this.btn_xyrotate) {
            this.action = ACTION.DragXYRotate;
        } else if (selection === this.btn_scale) {
            this.action = ACTION.DragScale;
        } else if (selection === this.btn_zrotate) {
            this.action = ACTION.DragZRotate;
        } else if (selection === this.btn_shrink) {
            this.action = ACTION.DragShrink;
        } else if (selection === this.btn_expand) {
            this.action = ACTION.DragExpand;
        } else {
            this.action = ACTION.None;
        }
    }

    translateObject(object, deltaX, deltaY) {
        // console.log("translateObject: ", object, deltaX, deltaY);
        if (object.parent !== null) {
            let scale = object.parent.getWorldScale(new THREE.Vector3());
            // console.log(scale);
            deltaX /= scale.x;
            deltaY /= scale.y;
        }
        // object.translateX(deltaX);
        // object.translateY(-deltaY);
        let orientation = this.getTryonImageOrientation() % 360;
        if (Math.abs(orientation) < 10) {
            object.position.x += deltaX;
            object.position.y -= deltaY;
        } else if (Math.abs(-90 - orientation) < 10 || Math.abs(270 - orientation) < 10) {
            object.position.x += deltaY;
            object.position.y += deltaX;
        } else if (Math.abs(-180 - orientation) < 10 || Math.abs(180 - orientation) < 10) {
            object.position.x -= deltaX;
            object.position.y += deltaY;
        } else if (Math.abs(90 - orientation) < 10 || Math.abs(-270 - orientation) < 10) {
            object.position.x -= deltaY;
            object.position.y -= deltaX;
        }
        // console.log("translate delta: " + deltaX + ", " + deltaY);
        // debugElement.textContent = 'translateObject: [' + deltaX + ', ' + deltaY + '], orientation: ' + orientation;
        // console.log(object.getWorldPosition());
        this.canSaveTryonData = true;
    }

    dragMoveObject(object, deltaX, deltaY) {
        if (object === this.tryonImagePlane) {
            // tryonImageRoot.translateX(deltaX);
            // tryonImageRoot.translateY(-deltaY);
            this.tryonImageRoot.position.x += deltaX;
            this.tryonImageRoot.position.y -= deltaY;

            this.limitTryonImagePosition();
        } else {
            this.translateObject(object, deltaX, deltaY);
        }
    }

    dragMoveObjectInMouse(object, event) {
        if (!this.preMouseEvent || !object)
            return;
        // console.log("moveObject");
        // console.log(object);
        let deltaX = event.clientX - this.preMouseEvent.clientX;
        let deltaY = event.clientY - this.preMouseEvent.clientY;
        // console.log("translate delta: " + deltaX + ", " + deltaY);
        this.dragMoveObject(object, deltaX, deltaY);

        this.preMouseEvent = event;
    }

    dragScaleObject(object, currClientX, currClientY, preClientX, preClientY, downClientX, downClientY, anchor, minScale, maxScale) {
        // console.log('dragScaleObject client pos: ', currClientX, currClientY, preClientX, preClientY, downClientX, downClientY);
        let currPos = this.clientPosToWorld(currClientX, currClientY, this.camera, 0);
        let prePos = this.clientPosToWorld(preClientX, preClientY, this.camera, 0);

        let moveDir = new THREE.Vector3();
        moveDir.subVectors(currPos, prePos);
        let objPos = object.getWorldPosition(new THREE.Vector3());
        objPos.z = 0;
        anchor.z = 0;
        let anchorDir = new THREE.Vector3();
        anchorDir.subVectors(objPos, anchor);
        // console.log('dragScaleObject direction: ', moveDir, anchorDir);
        // var cross = new THREE.Vector3();
        // cross.crossVectors(anchorDir, moveDir);
        let angle = anchorDir.clone().angleTo(moveDir);
        let degrees = THREE.Math.radToDeg(angle);
        // console.log('dragScaleObject angle: ', angle, degrees);
        if (degrees < 90) {
            this.zoomOutObject(object, this.getTryonObjectZoomScale(), minScale, maxScale);
        } else {
            this.zoomInObject(object, this.getTryonObjectZoomScale(), minScale, maxScale);
        }
    }

    dragScaleObjectInMouse(object, event, anchor, minScale, maxScale) {
        if (!this.preMouseEvent || !object)
            return;
        // var deltaX = event.clientX - preMouseEvent.clientX;
        // var deltaY = event.clientY - preMouseEvent.clientY;
        // console.log("move: " + deltaX + ", " + deltaY);
        // dragScaleObject(object, deltaX, deltaY, anchor, minScale, maxScale);
        this.dragScaleObject(object, event.clientX, event.clientY, this.preMouseEvent.clientX, this.preMouseEvent.clientY, this.mouseDownEvent.clientX, this.mouseDownEvent.clientY, anchor, minScale, maxScale);

        this.preMouseEvent = event;
    }

    dragScaleObjectInTouch(object, event, anchor, minScale, maxScale) {
        if (!this.preTouchEvent || !object)
            return;
        // var deltaX = event.clientX - preMouseEvent.clientX;
        // var deltaY = event.clientY - preMouseEvent.clientY;
        // console.log("move: " + deltaX + ", " + deltaY);
        // dragScaleObject(object, deltaX, deltaY, anchor, minScale, maxScale);
        this.dragScaleObject(object, event.clientX, event.clientY, this.preTouchEvent.clientX, this.preTouchEvent.clientY, this.touchStartEvent.clientX, this.touchStartEvent.clientY, anchor, minScale, maxScale);

        this.preTouchEvent = event;
    }

    dragScaleObjectInTouch(object, event, anchor, minScale, maxScale) {
        if (!this.preTouchEvent || !object)
            return;
        // var deltaX = event.clientX - preMouseEvent.clientX;
        // var deltaY = event.clientY - preMouseEvent.clientY;
        // console.log("move: " + deltaX + ", " + deltaY);
        // dragScaleObject(object, deltaX, deltaY, anchor, minScale, maxScale);
        this.dragScaleObject(object, event.clientX, event.clientY, this.preTouchEvent.clientX, this.preTouchEvent.clientY, this.touchStartEvent.clientX, this.touchStartEvent.clientY, anchor, minScale, maxScale);

        this.preTouchEvent = event;
    }

    dragXYRotateObject(object, deltaX, deltaY) {
        // console.log('dragXYRotateObject: ', object, deltaX, deltaY);
        let tryonType = object.tryonType || object.userData.tryonType;
        if (tryonType) {
            if (tryonType === '吊坠')
                return;
        }
        let orientation = this.getTryonImageOrientation() % 360;
        if (Math.abs(orientation) < 10) {
            if (Math.abs(deltaX) >= Math.abs(deltaY)) {
                if (deltaX > 0) {
                    object.rotateYOnWorld(THREE.Math.degToRad(1));
                    this.canSaveTryonData = true;
                } else if (deltaX < 0) {
                    object.rotateYOnWorld(-THREE.Math.degToRad(1));
                    this.canSaveTryonData = true;
                }
            } else {
                if (deltaY < 0) {
                    object.rotateXOnWorld(-THREE.Math.degToRad(1));
                    this.canSaveTryonData = true;
                } else if (deltaY > 0) {
                    object.rotateXOnWorld(THREE.Math.degToRad(1));
                    this.canSaveTryonData = true;
                }
            }
        } else if (Math.abs(-90 - orientation) < 10 || Math.abs(270 - orientation) < 10) {
            if (Math.abs(deltaX) >= Math.abs(deltaY)) {
                if (deltaX > 0) {
                    object.rotateXOnWorld(-THREE.Math.degToRad(1));
                    this.canSaveTryonData = true;
                } else if (deltaX < 0) {
                    object.rotateXOnWorld(THREE.Math.degToRad(1));
                    this.canSaveTryonData = true;
                }
            } else {
                if (deltaY < 0) {
                    object.rotateYOnWorld(-THREE.Math.degToRad(1));
                    this.canSaveTryonData = true;
                } else if (deltaY > 0) {
                    object.rotateYOnWorld(THREE.Math.degToRad(1));
                    this.canSaveTryonData = true;
                }
            }
        } else if (Math.abs(-180 - orientation) < 10 || Math.abs(180 - orientation) < 10) {
            if (Math.abs(deltaX) >= Math.abs(deltaY)) {
                if (deltaX > 0) {
                    object.rotateYOnWorld(-THREE.Math.degToRad(1));
                    this.canSaveTryonData = true;
                } else if (deltaX < 0) {
                    object.rotateYOnWorld(THREE.Math.degToRad(1));
                    this.canSaveTryonData = true;
                }
            } else {
                if (deltaY < 0) {
                    object.rotateXOnWorld(THREE.Math.degToRad(1));
                    this.canSaveTryonData = true;
                } else if (deltaY > 0) {
                    object.rotateXOnWorld(-THREE.Math.degToRad(1));
                    this.canSaveTryonData = true;
                }
            }
        } else if (Math.abs(90 - orientation) < 10 || Math.abs(-270 - orientation) < 10) {
            if (Math.abs(deltaX) >= Math.abs(deltaY)) {
                if (deltaX > 0) {
                    object.rotateXOnWorld(THREE.Math.degToRad(1));
                    this.canSaveTryonData = true;
                } else if (deltaX < 0) {
                    object.rotateXOnWorld(-THREE.Math.degToRad(1));
                    this.canSaveTryonData = true;
                }
            } else {
                if (deltaY < 0) {
                    object.rotateYOnWorld(THREE.Math.degToRad(1));
                    this.canSaveTryonData = true;
                } else if (deltaY > 0) {
                    object.rotateYOnWorld(-THREE.Math.degToRad(1));
                    this.canSaveTryonData = true;
                }
            }
        }
    }

    dragXYRotateObjectInMouse(object, event) {
        if (!this.preMouseEvent || !object)
            return;
        let tryonType = object.tryonType || object.userData.tryonType;
        if (tryonType) {
            if (tryonType === '吊坠')
                return;
        }

        let deltaX = event.clientX - this.preMouseEvent.clientX;
        let deltaY = event.clientY - this.preMouseEvent.clientY;

        this.dragXYRotateObject(object, deltaX, deltaY);

        this.preMouseEvent = event;
    }

    dragZRotateObjectInTouch(object, event) {
        if (!this.preTouchEvent || !object)
            return;
        // console.log("dragRotateObject: ", event, preTouchEvent);
        let anchor = object.getWorldPosition(new THREE.Vector3());
        let pos1 = this.clientPosToWorld(this.preTouchEvent.clientX, this.preTouchEvent.clientY, this.camera, anchor.z);
        let pos2 = this.clientPosToWorld(event.clientX, event.clientY, this.camera, anchor.z);
        let line1 = pos1.sub(anchor);
        let line2 = pos2.sub(anchor);
        let angle = this.computeCrossAngle(line1, line2);
        // console.log('angle: ', angle);
        object.rotateZOnWorld(-angle);

        this.preTouchEvent = event;
        this.canSaveTryonData = true;
    }

    dragZRotateObjectInMouse(object, event) {
        if (!this.preMouseEvent || !object)
            return;
        // console.log("dragZRotateObjectInMouse: ", event, this.preMouseEvent);
        let anchor = object.getWorldPosition(new THREE.Vector3());
        let pos1 = this.clientPosToWorld(this.preMouseEvent.clientX, this.preMouseEvent.clientY, this.camera, anchor.z);
        let pos2 = this.clientPosToWorld(event.clientX, event.clientY, this.camera, anchor.z);
        let line1 = pos1.sub(anchor);
        let line2 = pos2.sub(anchor);
        let angle = this.computeCrossAngle(line1, line2);
        // console.log('angle: ', angle);
        object.rotateZOnWorld(-angle);

        this.preMouseEvent = event;
        this.canSaveTryonData = true;
    }

    computeCrossAngle(from, to) {
        // console.log("computeCrossAngle");
        let cross = new THREE.Vector3();
        cross.crossVectors(from, to);
        // console.log(cross);
        let angle;
        if (cross.z < 0) {
            angle = from.angleTo(to);
        } else {
            angle = -from.angleTo(to);
        }
        // console.log("angle: " + angle);
        return angle;
    }

    dragShrinkChainOpened(object, deltaX, deltaY) {
        // console.log('dragShrinkChainObject: ', deltaX, deltaY);
        let orientation = this.getTryonImageOrientation() % 360;
        if (Math.abs(orientation) < 10) {
            object.traverse((child) => {
                if (child.name === 'joint1') {
                    let scale = child.getWorldScale(new THREE.Vector3());
                    let offset = deltaX / scale.x;
                    child.position.x += offset;
                    this.ensureLeftJointPos(child);
                    this.canSaveTryonData = true;
                } else if (child.name === 'joint3') {
                    let scale = child.getWorldScale(new THREE.Vector3());
                    let offset = deltaX / scale.x;
                    child.position.x -= offset;
                    this.ensureRightJointPos(child);
                    this.canSaveTryonData = true;
                }
            });
        } else if (Math.abs(-90 - orientation) < 10 || Math.abs(270 - orientation) < 10) {
            object.traverse((child) => {
                if (child.name === 'joint1') {
                    let scale = child.getWorldScale(new THREE.Vector3());
                    let offset = deltaY / scale.x;
                    child.position.x += offset;
                    this.ensureLeftJointPos(child);
                    this.canSaveTryonData = true;
                } else if (child.name === 'joint3') {
                    let scale = child.getWorldScale(new THREE.Vector3());
                    let offset = deltaY / scale.x;
                    child.position.x -= offset;
                    this.ensureRightJointPos(child);
                    this.canSaveTryonData = true;
                }
            });
        } else if (Math.abs(-180 - orientation) < 10 || Math.abs(180 - orientation) < 10) {
            object.traverse((child) => {
                if (child.name === 'joint1') {
                    let scale = child.getWorldScale(new THREE.Vector3());
                    let offset = deltaX / scale.x;
                    child.position.x -= offset;
                    this.ensureLeftJointPos(child);
                    this.canSaveTryonData = true;
                } else if (child.name === 'joint3') {
                    let scale = child.getWorldScale(new THREE.Vector3());
                    let offset = deltaX / scale.x;
                    child.position.x += offset;
                    this.ensureRightJointPos(child);
                    this.canSaveTryonData = true;
                }
            });
        } else if (Math.abs(90 - orientation) < 10 || Math.abs(-270 - orientation) < 10) {
            object.traverse((child) => {
                if (child.name === 'joint1') {
                    let scale = child.getWorldScale(new THREE.Vector3());
                    let offset = deltaY / scale.x;
                    child.position.x -= offset;
                    this.ensureLeftJointPos(child);
                    this.canSaveTryonData = true;
                } else if (child.name === 'joint3') {
                    let scale = child.getWorldScale(new THREE.Vector3());
                    let offset = deltaY / scale.x;
                    child.position.x += offset;
                    this.ensureRightJointPos(child);
                    this.canSaveTryonData = true;
                }
            });
        }
    }

    dragShrinkChainOpenedInMouse(object, event) {
        let deltaX = event.clientX - this.preMouseEvent.clientX;
        let deltaY = event.clientY - this.preMouseEvent.clientY;
        this.dragShrinkChainOpened(object, deltaX, deltaY);
        this.preMouseEvent = event;
    }

    dragExpandChainOpenedInMouse(object, event, anchor) {
        let deltaX = event.clientX - this.preMouseEvent.clientX;
        let deltaY = event.clientY - this.preMouseEvent.clientY;
        this.dragExpandChainOpened(object, deltaX, deltaY, anchor);
        this.preMouseEvent = event;
    }

    dragExpandChainOpened(object, deltaX, deltaY) {
        // console.log('dragExpandChainObject: ', deltaX, deltaY);
        let orientation = this.getTryonImageOrientation() % 360;
        if (Math.abs(orientation) < 10) {
            object.traverse((child) => {
                if (child.name === 'joint1') {
                    let scale = child.getWorldScale(new THREE.Vector3());
                    let offset = deltaX / scale.x;
                    child.position.x -= offset;
                    this.ensureLeftJointPos(child);
                    this.canSaveTryonData = true;
                } else if (child.name === 'joint3') {
                    let scale = child.getWorldScale(new THREE.Vector3());
                    let offset = deltaX / scale.x;
                    child.position.x += offset;
                    this.ensureRightJointPos(child);
                    this.canSaveTryonData = true;
                }
            });
        } else if (Math.abs(-90 - orientation) < 10 || Math.abs(270 - orientation) < 10) {
            object.traverse((child) => {
                if (child.name === 'joint1') {
                    let scale = child.getWorldScale(new THREE.Vector3());
                    let offset = deltaY / scale.x;
                    child.position.x -= offset;
                    this.ensureLeftJointPos(child);
                    this.canSaveTryonData = true;
                } else if (child.name === 'joint3') {
                    let scale = child.getWorldScale(new THREE.Vector3());
                    let offset = deltaY / scale.x;
                    child.position.x += offset;
                    this.ensureRightJointPos(child);
                    this.canSaveTryonData = true;
                }
            });
        } else if (Math.abs(-180 - orientation) < 10 || Math.abs(180 - orientation) < 10) {
            object.traverse((child) => {
                if (child.name === 'joint1') {
                    let scale = child.getWorldScale(new THREE.Vector3());
                    let offset = deltaX / scale.x;
                    child.position.x += offset;
                    this.ensureLeftJointPos(child);
                    this.canSaveTryonData = true;
                } else if (child.name === 'joint3') {
                    let scale = child.getWorldScale(new THREE.Vector3());
                    let offset = deltaX / scale.x;
                    child.position.x -= offset;
                    this.ensureRightJointPos(child);
                    this.canSaveTryonData = true;
                }
            });
        } else if (Math.abs(90 - orientation) < 10 || Math.abs(-270 - orientation) < 10) {
            object.traverse((child) => {
                if (child.name === 'joint1') {
                    let scale = child.getWorldScale(new THREE.Vector3());
                    let offset = deltaY / scale.x;
                    child.position.x += offset;
                    this.ensureLeftJointPos(child);
                    this.canSaveTryonData = true;
                } else if (child.name === 'joint3') {
                    let scale = child.getWorldScale(new THREE.Vector3());
                    let offset = deltaY / scale.x;
                    child.position.x -= offset;
                    this.ensureRightJointPos(child);
                    this.canSaveTryonData = true;
                }
            });
        }
    }

    ensureLeftJointPos(joint) {
        if (joint.position.x > this.chainLeftJointPosition.x)
            joint.position.x = this.chainLeftJointPosition.x;
        else if (joint.position.x < this.chainLeftJointPosition.x - this.chainMaxOpened)
            joint.position.x = this.chainLeftJointPosition.x - this.chainMaxOpened;
    }

    ensureRightJointPos(joint) {
        if (joint.position.x < this.chainRightJointPosition.x)
            joint.position.x = this.chainRightJointPosition.x;
        else if (joint.position.x > this.chainRightJointPosition.x + this.chainMaxOpened)
            joint.position.x = this.chainRightJointPosition.x + this.chainMaxOpened;
    }

    zoomInTryonImage(zoomScale) {
        // console.log("zoomInTryonImage: " + zoomScale);
        if (zoomScale == 1)
            return;
        this.zoomInObject(this.tryonImageRoot, zoomScale, this.tryonImageMinScale, this.tryonImageMaxScale);
        this.limitTryonImagePosition();
    }

    zoomOutTryonImage(zoomScale) {
        // console.log("zoomOutTryonImage: " + zoomScale);
        if (zoomScale == 1)
            return;
        this.zoomOutObject(this.tryonImageRoot, zoomScale, this.tryonImageMinScale, this.tryonImageMaxScale);
        this.limitTryonImagePosition();
    }

    pinchZoomTryonImage(zoomScale) {
        if (zoomScale == 1)
            return;
        this.pinchZoomObject(this.tryonImageRoot, zoomScale, this.tryonImageMinScale, this.tryonImageMaxScale);
        this.limitTryonImagePosition();
    }

    zoomInObject(object, zoomScale, minScale, maxScale) {
        // console.log("zoomInObject: " + zoomScale);
        if (!object || zoomScale == 1)
            return;
        let scale = object.scale.x;
        if (zoomScale < 1)
            scale /= zoomScale;
        else if (zoomScale > 1)
            scale *= zoomScale;
        if (scale < minScale)
            scale = minScale;
        else if (scale > maxScale)
            scale = maxScale;
        object.scale.set(scale, scale, scale);
        this.canSaveTryonData = true;
    }

    zoomOutObject(object, zoomScale, minScale, maxScale) {
        // console.log("zoomOutObject: " + zoomScale);
        if (!object || zoomScale == 1)
            return;
        let scale = object.scale.x;
        if (zoomScale > 1)
            scale /= zoomScale;
        else if (zoomScale < 1)
            scale *= zoomScale;
        if (scale < minScale)
            scale = minScale;
        else if (scale > maxScale)
            scale = maxScale;
        object.scale.set(scale, scale, scale);
        this.canSaveTryonData = true;
    }

    pinchZoomObject(object, zoomScale, minScale, maxScale) {
        // console.log("zoomObject: " + zoomScale);
        if (!object || zoomScale == 1)
            return;
        let scale = object.scale.x;
        scale *= zoomScale;
        if (scale < minScale)
            scale = minScale;
        else if (scale > maxScale)
            scale = maxScale;
        object.scale.set(scale, scale, scale);
        this.canSaveTryonData = true;
    }

    clientPosToNDC(clientX, clientY) {
        let rect = this.options.element.getBoundingClientRect();
        // console.log(rect);
        let ndc = new THREE.Vector2();
        ndc.x = ((clientX - rect.left) / rect.width) * 2 - 1;
        ndc.y = -((clientY - rect.top) / rect.height) * 2 + 1;
        // console.log('clientPosToNDC: ', ndc);
        return ndc;
    }

    clientPosToWorld(clientX, clientY, camera, depth) {
        if (this.camera == null)
            return;
        let ndc = this.clientPosToNDC(clientX, clientY);
        let position = new THREE.Vector3();
        if (this.camera.isOrthographicCamera) {
            position.set(ndc.x, ndc.y, (this.camera.near + this.camera.far) / (this.camera.near - this.camera.far)).unproject(this.camera);
            var z = depth !== undefined ? depth : 0;
            position.z = z;
        } else if (camera.isPerspectiveCamera) {
            // TODO
        } else {
            console.error("clientPosToWorld:  Unsupported camera type.");
        }
        // console.log('clientPosToWorld:', position);
        return position;
    }

    getTryonObjectZoomScale() {
        return Math.pow(0.99, 1);
    }

    getMouseWheelZoomScale() {
        return Math.pow(0.95, 1);
    }

    getQiniuToken(key, onFinished) {
        // $.ajax({
        //     url: this.getQiniuTokenUrl,
        //     cache: false,
        //     data: {
        //         type: 'tryon'
        //     },
        //     dataType: 'json',
        //     crossDomain: true,
        //     error: (xhr) => {
        //         console.error(xhr.error);
        //     },
        //     success: (response) => {
        //         console.log('getQiniuToken: ', response);
        //         if (onFinished)
        //             onFinished(response.data);
        //     },
        // });
        axios.get(this.getQiniuTokenUrl, {
            params: {
                key: key,
                bucket: 'gemtec-3d',
                type: 'tryon'
            }
        }).then((response) => {
            console.log('getQiniuToken: ', response);
            if (onFinished)
                onFinished(response.data.data);
        }).catch((error) => {
            console.error(error);
            alert(error);
        });
    }

    qiniuUpload(tokenData, fileName, fileData, onFinished, onFailed) {
        console.log('qiniuUpload: ', fileName);
        this.showLoadingProgress(0);
        // if (fileName) {
        //     var fileType = fileName.split('.').pop().toLowerCase();
        // }
        let putExtra = {
            fname: fileName || '',
            params: {},
            mimeType: null
        };
        let config = {
            useCdnDomain: true,
            // checkByMD5: true
        };
        let key;
        if (fileName) {
            key = fileName;
        } else {
            key = tokenData.key;
        }
        let observable = qiniu.upload(fileData, key, tokenData.token, putExtra, config);
        let subscription = observable.subscribe((res) => {
            let total = res.total;
            let progress = total.percent / 100;
            // console.log('qiniuUpload progress: ', progress, total);
            this.showLoadingProgress(progress);
        }, (error) => {
            console.error('qiniuUpload error: ', error);
            this.hideLoadingProgress();
            alert('上传失败: ' + error.message);
            if (onFailed)
                onFailed(error);
        }, (response) => {
            response.url = tokenData.domain + '/' + key;
            console.log('qiniuUpload response: ', response);
            this.hideLoadingProgress();
            // alert('上传完成: ' + response.key);
            if (onFinished)
                onFinished(response);
        });
    }

    qiniuDelete(key, onFinished, onFailed) {
        axios.post(this.qiniuDeleteUrl, {
            key: key,
            bucket: 'gemtec-3d'
        }, {
            headers: {
                'Authorization': this.loginToken
            }
        }).then((response) => {
            console.log('qiniuDelete: ', response);
            if (response.data.code === 10200) {
                if (onFinished)
                    onFinished(response.data);
            } else {
                if (onFailed)
                    onFailed(response.message);
            }
        }).catch((error) => {
            console.error(error);
            if (onFailed)
                onFailed(error);
        });
    }

    getTryonImageOrientation() {
        return parseInt(THREE.Math.radToDeg(this.tryonImagePlane.rotation.z));
    }

    getTryonData() {
        let output = {
            tryonImage: {},
            objectList: []
        };
        if (this.tryonImagePlane.material.map) {
            output.tryonImage.position = {
                x: this.tryonImageRoot.position.x,
                y: this.tryonImageRoot.position.y,
                z: this.tryonImageRoot.position.z
            };
            output.tryonImage.rotation = {
                x: this.tryonImageRoot.rotation.x,
                y: this.tryonImageRoot.rotation.y,
                z: this.tryonImageRoot.rotation.z
            };
            output.tryonImage.scale = {
                x: this.tryonImageRoot.scale.x,
                y: this.tryonImageRoot.scale.y,
                z: this.tryonImageRoot.scale.z
            };
            if (this.tryonImagePlane.material.map.url) {
                output.tryonImage.url = this.tryonImagePlane.material.map.url;
            } else {
                output.tryonImage.url = this.tryonImagePlane.material.map.image.src;
            }
            output.tryonImage.orientation = this.getTryonImageOrientation();
        }
        for (let i = 0; i < this.tryonObjectArray.length; i++) {
            let object = this.tryonObjectArray[i];
            let tryonType = object.tryonType || object.userData.tryonType;
            let outputObj = {
                position: {
                    x: object.position.x,
                    y: object.position.y,
                    z: object.position.z
                },
                rotation: {
                    x: object.rotation.x,
                    y: object.rotation.y,
                    z: object.rotation.z
                },
                scale: {
                    x: object.scale.x,
                    y: object.scale.y,
                    z: object.scale.z
                },
                tryonType: tryonType,
                visible: object.visible
            };
            if (tryonType === '吊坠') {
                object.traverse((child) => {
                    if (child.name === 'joint1') {
                        outputObj.leftJointX = child.position.x;
                    } else if (child.name === 'joint3') {
                        outputObj.rightJointX = child.position.x;
                    }
                });
            }
            output.objectList.push(outputObj);
        }
        return output;
    }

    getTryonDataJson() {
        let json = JSON.stringify(this.getTryonData());
        return json;
    }

    saveTryonDataToServer(onFinished) {

        this.showLoadingProgress(0);
        let key, fileName;
        if (this.selectedTryonImageButton) {
            key = this.selectedTryonImageButton.key;
            fileName = THREE.LoaderUtils.extractFileName(key);
            fileName = this.userId + '_' + this.productId + '_' + fileName;
        } else {
            fileName = key = this.customKey;
        }

        let json = this.getTryonDataJson();
        // console.log('json: ', json);
        let time = new Date().getTime();
        this.getQiniuToken(fileName, (tokenData) => {
            let blob = new Blob([json], {
                type: 'text/plain;charset=utf-8'
            });
            this.qiniuUpload(tokenData, fileName, blob, (response) => {
                let url = response.url + '?t=' + time; //tokenData.domain + '/' + response.key;
                if (this.selectedTryonImageButton)
                    this.selectedTryonImageButton.dataUrl = url;
                else {
                    if (this.customButton)
                        this.customButton.dataUrl = url;
                    else {
                        this.customButton = this.addTryonImageButton(this.customIcon, url, this.customKey);
                        this.customButton.isCustom = true;
                    }
                    this.changeSelectedTryonImageButton(this.customButton);
                }
                this.tryOnDataDict[key] = url;
                // console.log('tryOnDataDict: ', this.tryOnDataDict);
                this.updateProductTryonDatas(() => {
                    this.hideLoadingProgress();
                    this.showRemoveButton();
                    alert('保存成功');
                }, (error) => {
                    this.hideLoadingProgress();
                    alert(error);
                });
            });
        });

    }

    saveTryonDataToFile() {
        this.saveString(this.getTryonDataJson());
    }

    saveTryonDataToLocalStorage(onScuccess, onError) {
        if (this.supportLocalStorage()) {
            if (this.saveToLocalStorage(this.localStorageKey, getTryonDataJson())) {
                console.log('saveTryonDataToLocalStorage success.');
                // alert('保存成功，再次打开本网页时会自动加载');
                if (onScuccess)
                    onScuccess(this.localStorageKey);
                return true;
            } else {
                console.error('saveTryonDataToLocalStorage failed.');
                alert('保存失败，请检查浏览器本地存储设置');
                if (onError)
                    onError(this.localStorageKey);
                return false;
            }
        } else {
            console.error('Unsupported window.localStorage');
            alert('该浏览器不支持本地存储');
            if (onError)
                onError(this.localStorageKey);
            return false;
        }
    }

    deleteSelectedTryonData() {
        if (this.selectedTryonImageButton) {
            let key = this.selectedTryonImageButton.key;
            // let url = this.tryOnDataDict[key];
            // let fileName = THREE.LoaderUtils.extractFileName(url);
            delete this.tryOnDataDict[key];
            this.updateProductTryonDatas(() => {
                alert('删除成功');
            }, (error) => {
                alert(error);
            });
            // this.qiniuDelete(fileName);
            if (this.selectedTryonImageButton !== this.customButton) {
                this.selectedTryonImageButton.dataUrl = key;
                this.selectedTryonImageButton.isCustom = false;
                this.changeSelectedTryonImageButton(this.selectedTryonImageButton);
            } else {
                this.removeTryonImageButton(this.customButton);
                delete this.customButton;
            }
        }
    }

    loadFile() {
        // console.log("loadFile");

        if (!this.fileInput) {
            let form = this.form = document.createElement('form');
            form.style.display = 'none';
            this.options.element.appendChild(form);

            let readFile = (file, fileType) => {
                let reader = new FileReader();
                reader.addEventListener('progress', (event) => {

                    // console.log(event);
                    // var size = '(' + Math.floor( event.total / 1000 ).format() + ' KB)';
                    // var progress = Math.floor( ( event.loaded / event.total ) * 100 ) + '%';
                    // console.log( 'Loading', filename, size, progress );

                });

                reader.addEventListener('load', (event) => {
                    // console.log('FileReader: ', event);
                    switch (fileType) {
                        case 0:
                            let contents = event.target.result;
                            // console.log(contents);
                            let data = JSON.parse(contents);
                            this.readTryonData(data);
                            break;
                        case 1:
                            console.error("Unsupported file type");
                            break;
                        case 2:
                            let image = document.createElement('img');
                            image.addEventListener('load', (event) => {

                                this.inputTryonImage(image);
                                this.resetAllTryonObjectInAdapterScreen();
                                // if (!DebugMode)
                                // this.showSaveButton();
                                this.changeSelectedTryonImageButton(null);
                                this.canSaveTryonData = true;

                            }, false);

                            image.src = event.target.result;
                            break;
                    }

                }, false);

                switch (fileType) {
                    case 0: //text
                        reader.readAsText(file);
                        break;
                    case 1: //image/targa
                        reader.readAsArrayBuffer(file);
                        break;
                    case 2: //image
                        reader.readAsDataURL(file);
                        break;
                }

                form.reset();
            };

            let fileInput = this.fileInput = document.createElement('input');
            fileInput.type = 'file';
            fileInput.accept = 'image/*';
            fileInput.addEventListener('change', (event) => {

                let file = fileInput.files[0];
                let fileType = 0;
                if (file.type.match('image.*')) {
                    if (file.type === 'image/targa') {
                        fileType = 1;
                    } else {
                        fileType = 2;
                    }
                    // 移动端，图片先上传至服务器再下载
                    // if (this.browser.isMobile) {
                    //调用七牛压缩图片
                    qiniu.compressImage(file, {
                        maxWidth: 1080
                    }).then((result) => {
                        // console.log('qiniu.compressImage result: ', result);
                        file = new File([result.dist], file.name);
                        readFile(file, fileType);
                    });

                    return;
                }

                readFile(file, fileType);

            });
            form.appendChild(this.fileInput);
        }
        this.fileInput.click();
    }

    inputTryonImage(image) {
        // console.log('inputTryonImage: ', image);
        let texture = new THREE.Texture(image);
        // texture.sourceFile = file.name;
        // texture.needsUpdate = true;

        this.updateTryonImage(texture);
    }

    doScreenshot() {
        // console.log("doScreenshot");
        try {
            this.render();

            let imgData = this.renderer.domElement.toDataURL("image/jpeg").replace("image/jpeg", "image/octet-stream");

            this.saveImage(imgData);
        } catch (error) {
            console.error(error);
            alert(error);
        }
    }

    doScreenshotAndQiniuUpload(onFinished) {
        try {
            this.render();

            let imgData = THREE.ImageUtils.dataURLtoBlob(this.renderer.domElement.toDataURL("image/jpeg"));
            // renderer.domElement.toDataURL("image/jpeg").replace("image/jpeg", "image/octet-stream");

            let fileName = 'screenshot_' + new Date().toLocaleString() + '.jpeg';

            this.getQiniuToken(fileName, (tokenData) => {
                this.qiniuUpload(tokenData, fileName, imgData, (response) => {
                    let url = response.url; //tokenData.domain + '/' + response.key;
                    if (onFinished)
                        onFinished(url);
                });
            });
        } catch (error) {
            console.error(error);
            alert(error);
        }
    }

    ensureLink() {
        if (!this.link) {
            let link = this.link = document.createElement('a');
            link.style.display = 'none';
            this.options.element.appendChild(link);
        } // Firefox workaround, see #6594
    }

    save(blob, filename) {
        this.ensureLink();
        this.link.href = URL.createObjectURL(blob);
        this.link.download = filename || 'data.json';
        this.link.click();
    }

    saveString(text, filename) {
        this.save(new Blob([text], {
            type: 'text/plain'
        }), filename);
    }

    saveImage(imgData, filename) {
        this.ensureLink();
        this.link.href = imgData;
        this.link.download = filename || 'screenshot_' + new Date().toLocaleString() + '.jpeg';
        this.link.click();
    }

    supportLocalStorage() {
        // console.log('supportLocalStorage: ', window.localStorage);
        return window.localStorage !== undefined
    }

    saveToLocalStorage(key, value) {
        if (window.localStorage === undefined)
            return false;
        // console.log('saveToLocalStorage: ', key, value);
        window.localStorage.setItem(key, value);
        return true;
    }

    readFromLocalStorage(key) {
        if (window.localStorage === undefined)
            return false;
        return window.localStorage.getItem(key);
    }

    checkLocalStorageSaved(key) {
        if (window.localStorage === undefined)
            return false;
        if (window.localStorage.getItem(key))
            return true;
        else
            return false;
    }

    deleteLocalStorageSave(key) {
        if (window.localStorage === undefined)
            return false;
        window.localStorage.removeItem(key);
        return true;
    }

    onResize() {
        if (super.onResize()) {

            this.directionalLight.shadow.camera.left = this.camera.left;
            this.directionalLight.shadow.camera.right = this.camera.right;
            this.directionalLight.shadow.camera.top = this.camera.top;
            this.directionalLight.shadow.camera.bottom = this.camera.bottom;
            this.directionalLight.shadow.camera.updateProjectionMatrix();

            this.adapterTryonImageScale();
        }
    }

    onFrameUpdate() {
        this.bindTryonObjectControlMenuProperties(this.selectedObject);
    }

    dispose() {
        this.disposeControls();
        if (this.link) {
            this.options.element.removeChild(this.link);
        }
        if (this.form) {
            this.options.element.removeChild(this.form);
        }
        if (this.tryonface) {
            this.options.element.removeChild(this.tryonface);
        }
        if (this.loadingProgressWindow) {
            this.options.element.removeChild(this.loadingProgressWindow);
        }
        super.dispose();
    }
};

// let tryonView = new GT3DTryon({
//     element: document.getElementById('gt3d-content'),
//     // baseUrl: 'http://t.p.gemtec.ltd',
//     // id: '5c34148b85563a4936249480',
//     id: '5c7784a842268935b464d92a',
//     token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiIsImp0aSI6IjIifQ.eyJpc3MiOiJcL1wvdHR4LmdlbXRlYy5sdGQiLCJpYXQiOjE1NTQ3OTg4NzAsIm5iZiI6MTU1NDc5ODg3MSwiZXhwIjoxNTU2MDA4NDcwLCJqdGkiOiIyIiwidWlkIjoyLCJzdWIiOjJ9.3RUcqJOpDCmxJtcVEm0oHMTBMWloc7JthW_nN9FzsGY',
// });